import React, { useEffect, useRef, useState } from 'react';
import { aiPowered, allen, analysis, ArrowRight, bharatSUre, BoyWithLaptop, BrianSimmonsImg, calender, cardRightArrow, CareerIcon, click, dashboardats, DummyProfileImg, DummyProfileImg1, GroupOfFourIcon, heroBanner1, heroBanner2, heroBanner3, idCardIcon, idea, lineWithPlus, MoreWithBoxIcon, MsgGrey, offer, OnboardingIcon, PresentationIcon, QuesAnsChatIcon, rapido, rapidoSvg, SearchPropleIcon, SuccessIcon, SuccessTrophyIcon, tata, thinkingIcon, trustedCompany, writingNotesIcon, macrocosmos, sanjivani, yelloskye } from "../assets/images";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation, Pagination, Scrollbar, A11y } from 'swiper/modules';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from '@gsap/react';
import { postApi, showToast } from '../services/apiService.tsx';
import { ServiceType } from '../constants/baseUrls.tsx';
import { ToastType } from '../components/Toast.tsx';
import { ResponseTypes } from '../constants/enum.tsx';

gsap.registerPlugin(ScrollTrigger); // Register the plugin
gsap.registerPlugin(useGSAP);

const cardData = [
	{
		id: 1,
		headerText: "Recruitment",
		content: "Streamline Recruitment to Build Your Dream Team",
		icons: [<SuccessIcon key="1" />, <OnboardingIcon key="2" />],
	},
	{
		id: 2,
		headerText: "Onboarding",
		content: "Seamless Onboarding for Smarter Workforce Management",
		icons: [<SuccessIcon key="1" />, <OnboardingIcon key="2" />],
	},
	{
		id: 3,
		headerText: "Learn, Perform & Engage",
		content: "Seamless Onboarding for Smarter Workforce Management",
		icons: [<SuccessIcon key="1" />, <OnboardingIcon key="2" />],
	},
	{
		id: 4,
		headerText: "Payroll",
		content: "Seamless Onboarding for Smarter Workforce Management",
		icons: [<SuccessIcon key="1" />, <OnboardingIcon key="2" />],
	},
	{
		id: 5,
		headerText: "Offboarding",
		content: "Seamless Onboarding for Smarter Workforce Management",
		icons: [<SuccessIcon key="1" className="success-icon" />, <OnboardingIcon key="2" />],
	},
];

const Home = () => {
	const [hoveredCard, setHoveredCard] = useState(1);
	const [isMobile, setIsMobile] = useState(false);
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [formData, setFormData] = useState({
		workEmail: '',
		firstName: '',
		lastName: '',
		country: 'India',
		phone: '',
		companyName: '',
		numberOfEmployees: '',
		seniority: '',
		functionalArea: '',
		customisation: '',
		agreedToTerms: false,
		modules: []
	});

	useEffect(() => {
		const handleResize = () => {
			if (window.innerWidth <= 992) {
				setIsMobile(true);
			} else {
				setIsMobile(false);
			}
		};

		handleResize();
		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	const handleMouseEnter = (cardIndex) => {
		setHoveredCard(cardIndex);
	};

	// Check if all required fields are filled
	const isFormValid = () => {
		return (
			formData.workEmail.trim() !== '' &&
			formData.firstName.trim() !== '' &&
			formData.lastName.trim() !== '' &&
			formData.companyName.trim() !== '' &&
			formData.numberOfEmployees !== '' &&
			formData.seniority !== '' &&
			formData.functionalArea !== '' &&
			formData.agreedToTerms === true &&
			formData.modules.length > 0
		);
	};

	const handleOpenModal = () => {
		setIsModalOpen(true);
		document.body.style.overflow = 'hidden';
	};

	const handleCloseModal = () => {
		setIsModalOpen(false);
		document.body.style.overflow = 'unset';
	};

	const handleInputChange = (e) => {
		const { name, value, type, checked } = e.target;
		setFormData(prev => ({
			...prev,
			[name]: type === 'checkbox' ? checked : value
		}));
	};

	const handleModuleChange = (module) => {
		setFormData(prev => ({
			...prev,
			modules: prev.modules.includes(module)
				? prev.modules.filter(m => m !== module)
				: [...prev.modules, module]
		}));
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		
		setIsSubmitting(true);
		
		try {
			// Prepare the API payload
			const apiPayload = {
				form_data: {
					"Work Email": formData.workEmail,
					"First Name": formData.firstName,
					"Last Name": formData.lastName,
					"Country": formData.country,
					"Phone": formData.phone,
					"Company Name": formData.companyName,
					"Number of Employees": formData.numberOfEmployees,
					"Seniority": formData.seniority,
					"Functional Area": formData.functionalArea,
					"Any other customisation": formData.customisation,
					"Modules Interested in": formData.modules.join(', ')
				}
			};

			// Call the API
			const response = await postApi(
				'/v1/enquiry-form',
				apiPayload,
				ServiceType.DASHBOARD,
				undefined,
				undefined,
				false,
				false
			);

			if (response.status === ResponseTypes.SUCCESS) {
				showToast('Your enquiry has been submitted successfully!', ToastType.SUCCESS);
				handleCloseModal();
				setFormData({
					workEmail: '',
					firstName: '',
					lastName: '',
					country: 'India',
					phone: '',
					companyName: '',
					numberOfEmployees: '',
					seniority: '',
					functionalArea: '',
					customisation: '',
					agreedToTerms: false,
					modules: []
				});
			} else {
				showToast('Failed to submit enquiry. Please try again.', ToastType.ERROR);
			}
		} catch (error) {
			console.error('Error submitting form:', error);
			showToast('Failed to submit enquiry. Please try again.', ToastType.ERROR);
		} finally {
			setIsSubmitting(false);
		}
	};

	// ---------------GSAP Animations-------------------
	const headingRef = useRef(null); // Reference for the heading
	const subheadingRef = useRef(null); // Reference for the heading
	const industryheadingRef = useRef(null);
	const bookDemoHeadingRef = useRef(null);
	const bookDemoSubHeadingRef = useRef(null);
	const cardsRef = useRef([]); // Array to store references for all boxes
	const PScardsRef = useRef([]); // Array to store references for all boxes
	const decisionsCardsRef = useRef([]);
	const atsCardsRef = useRef([]);
	const journeyCardRef = useRef([]);
	const iconsRef = useRef([]);

	// function for animation resuable function
	const cardInfunction = (item) => {
		return gsap.fromTo(
			item,
			{
				opacity: 0, // Start with full transparency
				y: 30, // Slide up from 30px below
				scale: 1.1, // Slightly zoomed out
				filter: 'blur(2px)', // Start with blur
			},
			{
				opacity: 1, // Fully visible
				y: 0, // Move to the original position
				scale: 1, // Normal scale
				filter: 'blur(0px)', // Remove blur
				ease: "power2.inOut", // Smooth easing effect for natural motion
				scrollTrigger: {
					trigger: item, // Trigger the animation when the card comes into view
					start: "top 95%", // Animation starts when the top of the card is at 80% of the viewport
					end: "top 80%", // Animation ends at 50% of the viewport
					toggleActions: "play none none none", // Rewind animation when scrolling back
				},
			}
		);
	}

	// Function for animating the cards one after another
	const animateCards = (item) => {
		gsap.fromTo(
			item,
			{ opacity: 0, y: 50 }, // Start: hidden and slightly below its position
			{
				opacity: 1,
				y: 0,
				duration: 0.5, // Duration for each card
				ease: "power1.out",
				stagger: 0.2, // Delay between each card's animation
				scrollTrigger: {
					trigger: item, // Trigger animation when the parent is in view
					start: "top 80%", // Start animation when the container is 80% in the viewport
					end: "bottom 20%", // End the animation when the container reaches the bottom of the viewport
					// scrub: true, // Smooth scrolling effect
				},
			}
		);
	};

	const animateHeading = (headingRef) => {
		gsap.fromTo(
			headingRef.current,
			{ opacity: 0, y: 50 },
			{ opacity: 1, y: 0, duration: 2, ease: "power1.out" }
		);
	};

	const animateSubHeading = (headingRef) => {
		gsap.fromTo(
			headingRef.current,
			{ opacity: 0, y: 50 },
			{ opacity: 1, y: 0, duration: 2, delay: 0.6, ease: "power1.out" }
		);
	};

	useGSAP(() => {
		// Create a context for all animations
		const ctx = gsap.context(() => {
			// Reset all elements to their initial state
			const resetElements = () => {
				// Reset cards
				[decisionsCardsRef.current, atsCardsRef.current, journeyCardRef.current].forEach(cards => {
					if (cards && cards.length) {
						gsap.set(cards, {
							opacity: 0,
							y: 30,
							clearProps: 'all'
						});
					}
				});

				// Reset floating icons
				if (iconsRef.current && iconsRef.current.length) {
					iconsRef.current.forEach((icon, index) => {
						if (!icon) return;
						const animations = [
							{ x: -250, y: -250 },
							{ x: -250, y: -250 },
							{ x: -100, y: 100 },
							{ x: -100, y: 100 },
							{ x: 200, y: -200 },
							{ x: 200, y: -200 },
							{ x: 150, y: 150 },
							{ x: 150, y: 150 },
						];
						gsap.set(icon, {
							x: animations[index]?.x || 0,
							y: animations[index]?.y || 0,
							opacity: 0,
							clearProps: 'all'
						});
					});
				}

				// Reset empower cards
				if (cardsRef.current && cardsRef.current.length) {
					gsap.set(cardsRef.current, {
						opacity: 0,
						y: 30,
						clearProps: 'all'
					});
				}
			};

			// Reset elements before starting new animations
			resetElements();

			// Animate the heading to slide in from the bottom
			animateHeading(headingRef)
			animateHeading(industryheadingRef)
			animateHeading(bookDemoHeadingRef)
			animateSubHeading(subheadingRef)

			gsap.fromTo(
				bookDemoSubHeadingRef.current,
				{ opacity: 0, y: 50 },
				{ opacity: 1, y: 0, duration: 2, delay: 0.5, ease: "power1.out" }
			);

			// Optimize card animations
			const animateCardsOptimized = (cards) => {
				if (!cards || !cards.length) return;
				
				gsap.fromTo(
					cards,
					{
						opacity: 0,
						y: 30,
						willChange: 'transform, opacity',
					},
					{
						opacity: 1,
						y: 0,
						duration: 0.6,
						stagger: 0.1,
						ease: "power2.out",
						scrollTrigger: {
							trigger: cards[0],
							start: "top 85%",
							toggleActions: "play none none none",
							once: true,
							fastScrollEnd: true,
							markers: false,
							onEnter: () => {
								// Force animation to play if it hasn't started
								gsap.to(cards, {
									opacity: 1,
									y: 0,
									duration: 0.6,
									stagger: 0.1,
									ease: "power2.out"
								});
							}
						},
						onComplete: () => {
							gsap.set(cards, { willChange: 'auto' });
						}
					}
				);
			};

			// Optimize floating icons animation
			const animateFloatingIcons = () => {
				if (!iconsRef.current || !iconsRef.current.length) return;

				const animations = [
					{ x: -250, y: -250 },
					{ x: -250, y: -250 },
					{ x: -100, y: 100 },
					{ x: -100, y: 100 },
					{ x: 200, y: -200 },
					{ x: 200, y: -200 },
					{ x: 150, y: 150 },
					{ x: 150, y: 150 },
				];

				iconsRef.current.forEach((icon, index) => {
					if (!icon) return;
					
					const animation = animations[index];
					
					// Set initial state
					gsap.set(icon, {
						x: animation.x,
						y: animation.y,
						opacity: 0,
						filter: "blur(4px)",
						willChange: 'transform, opacity, filter'
					});

					// Create the scroll-based animation
					ScrollTrigger.create({
						trigger: icon,
						start: "top 90%",
						end: "top 20%",
						scrub: 1, // Increased scrub value for smoother movement
						onUpdate: (self) => {
							// Calculate progress based on scroll position
							const progress = self.progress;
							
							// Smoothly animate based on scroll progress
							gsap.to(icon, {
								x: animation.x * (1 - progress),
								y: animation.y * (1 - progress),
								opacity: progress,
								filter: `blur(${4 * (1 - progress)}px)`,
								duration: 0.1, // Very short duration for smooth updates
								ease: "none",
								overwrite: true // Prevent animation conflicts
							});
						},
						onEnter: () => {
							// Initial animation when first entering viewport
							gsap.to(icon, {
								x: 0,
								y: 0,
								opacity: 1,
								filter: "blur(0px)",
								duration: 1,
								ease: "power2.out"
							});
						},
						onLeaveBack: () => {
							// Reset when scrolling back up
							gsap.to(icon, {
								x: animation.x,
								y: animation.y,
								opacity: 0,
								filter: "blur(4px)",
								duration: 0.8,
								ease: "power2.in"
							});
						}
					});
				});
			};

			// Optimize empower cards animation
			const animateEmpowerCards = () => {
				if (!cardsRef.current || !cardsRef.current.length) return;

				cardsRef.current.forEach((card, index) => {
					if (!card) return;

					gsap.fromTo(
						card,
						{
							opacity: 0,
							y: 30,
							willChange: 'transform, opacity',
						},
						{
							opacity: 1,
							y: 0,
							duration: 0.6,
							delay: index * 0.1,
							ease: "power2.out",
							scrollTrigger: {
								trigger: card,
								start: "top 85%",
								toggleActions: "play none none none",
								once: true,
								fastScrollEnd: true,
								onEnter: () => {
									// Force animation to play if it hasn't started
									gsap.to(card, {
										opacity: 1,
										y: 0,
										duration: 0.6,
										ease: "power2.out"
									});
								}
							},
							onComplete: () => {
								gsap.set(card, { willChange: 'auto' });
							}
						}
					);
				});
			};

			// Initialize animations with a small delay to ensure DOM is ready
			setTimeout(() => {
				animateCardsOptimized(decisionsCardsRef.current);
				animateCardsOptimized(atsCardsRef.current);
				animateCardsOptimized(journeyCardRef.current);
				animateFloatingIcons();
				animateEmpowerCards();
			}, 100);
		});

		// Cleanup function
		return () => {
			// Kill all ScrollTrigger instances
			ScrollTrigger.getAll().forEach(trigger => {
				trigger.kill();
			});
			
			// Clear all GSAP animations
			gsap.globalTimeline.clear();
			
			// Revert all GSAP changes
			ctx.revert();
		};
	}, []);
	// ---------------GSAP Animations-------------------

	return (
		<>
			<section className="hero-section">
				<div className="container">
					<div className="hero-content">
						<h1 ref={headingRef} style={{ transform: "translateY(50px)" }}>
							Transforming HR Journey With
							<br />
							<span  ref={subheadingRef} className="primary-text-color">
								{" "}
								All-In-One Intuitive Platform
							</span>
						</h1>
						<p className="text-heading-2">
							Created to bridge the gaps in traditional HR systems,
							Symplora simplifies complex workflows, delivering the
							transformation your workplace deserves.
						</p>
					</div>
					<div className="button-wrapper">
						<button className="btn btn--primary btn--regular" onClick={handleOpenModal}>
							Schedule a Demo
						</button>
						<button className="btn btn--white btn--regular">
							Explore More
						</button>
					</div>
					<div className="hero-img-wrapper">
						<div className="left-img-col">
							<img src={heroBanner1} alt="img 1" />
						</div>
						<div className="right-img-col">
							<img src={heroBanner2} alt="img 2" />
							<img src={heroBanner3} alt="img 3" />
						</div>
					</div>
				</div>
			</section>

			{/*------------Clients-section------------*/}
			<section className="clients-section">
				<div className="container">
					<p className="text-center  text-transform-uppercase fw-700 text-heading-1" ref={industryheadingRef} style={{ transform: "translateY(50px)" }}>Trusted by industry leaders</p>
					<div className="img-wrapper flex justify-center marquee" >
						{!isMobile && <><div className="flex align-center">
							<img className="client-logo" src={sanjivani} alt="sanjivani-logo" />
						</div>
						<div className="flex align-center">
							<img className="client-logo" src={bharatSUre} alt="bharatSUre-logo" />
						</div>
						<div className="flex align-center">
							<img className="client-logo" src={yelloskye} alt="yelloskye-logo" />
						</div>
						<div className="flex align-center">
							<img className="client-logo" src={macrocosmos} alt="macrocosmos-logo" />
						</div></>}
						{/* <div className="flex align-center">
							<img src={rapido} alt="rapido-logo" />
						</div> */}
						{/* <div className="flex align-center">
							<img src={tata} alt="tata-logo" />
						</div> */}
						{/* <div className="flex align-center">
							<img src={trustedCompany} alt="company-logo" />
						</div> */}
						{/* <div className="flex align-center">
							<img src={allen} alt="allen-logo" />
						</div> */}
						{isMobile && (
							<>
								<div className="flex align-center">
									<img className="client-logo-mobile" src={sanjivani} alt="sanjivani-logo" />
								</div>
								<div className="flex align-center">
									<img className="client-logo-mobile" src={bharatSUre} alt="bharatSUre-logo" />
								</div>
								<div className="flex align-center">
									<img className="client-logo-mobile" src={yelloskye} alt="yelloskye-logo" />
								</div>
								<div className="flex align-center">
									<img className="client-logo-mobile" src={macrocosmos} alt="macrocosmos-logo" />
								</div>
								{/* <div className="flex align-center">
									<img src={rapido} alt="rapido-logo" />
								</div>
								<div className="flex align-center">
									<img src={tata} alt="tata-logo" />
								</div>
								<div className="flex align-center">
									<img src={trustedCompany} alt="company-logo" />
								</div>
								<div className="flex align-center">
									<img src={allen} alt="allen-logo" />
								</div>
								<div className="flex align-center">
									<img src={bharatSUre} alt="bharatSUre-logo" />
								</div>
								<div className="flex align-center">
									<img src={rapido} alt="rapido-logo" />
								</div>
								<div className="flex align-center">
									<img src={tata} alt="tata-logo" />
								</div>
								<div className="flex align-center">
									<img src={trustedCompany} alt="company-logo" />
								</div>
								<div className="flex align-center">
									<img src={allen} alt="allen-logo" />
								</div> */}
							</>
						)}
					</div>
				</div>
			</section >
			{/*------------Clients-section------------*/}

			{/* ----------- empower HR section ------------ */}
			<section className="empower-hr-section container">
				<h2 className="text-heading text-center">Empower HR Management, Elevate Workplaces</h2>
				<p className="text-subheading text-center text-light-1">Created to bridge the gaps in traditional HR systems, Symplora simplifies complex workflows, delivering the transformation your workplace deserves.</p>
				<div className="flex justify-center">
					<button className="btn btn--regular btn--text learn-more-btn">Learn more about our product <span className="flex icon"><ArrowRight /></span></button>
				</div>

				<div className="empower-cards-con">
					{cardData.map((card, index) => (
						<React.Fragment key={card.id}>
							<div className={`empower-card ${index === 0 ? 'first-card' :
								index === 1 ? 'second-card' :
									index === 2 ? 'third-card' :
										index === 3 ? 'forth-card' :
											'fifth-card'
								} card-${index + 1}`} ref={(el) => (cardsRef.current[index] = el)}>
								<div className="empower-card-header fw-500">
									<div>
										{card.icons.map((icon, i) => (
											<span key={i}>{icon}</span>
										))}
										<span className="text-subheading">{card.headerText}</span>
									</div>
									<div className="action-btns">
										<MsgGrey />
										<MoreWithBoxIcon />
									</div>
								</div>
								<div className="empower-card-content text-body fw-600">{card.content}</div>
							</div>
							{index < cardData.length - 1 && (
								<div className="divider-icon">
									<img src={lineWithPlus} alt="line with plus" />
								</div>
							)}
						</React.Fragment>
					))}

					{/* floating icons */}
					<span className="floting-icon-1" ref={(el) => (iconsRef.current[0] = el)}><img src={SuccessTrophyIcon} alt="success icon" /></span>
					<span className="floting-icon-2" ref={(el) => (iconsRef.current[1] = el)}><img src={GroupOfFourIcon} alt="GroupOfFourIcon " /></span>
					<span className="floting-icon-3" ref={(el) => (iconsRef.current[2] = el)}><img src={QuesAnsChatIcon} alt="success icon" /></span>
					<span className="floting-icon-4" ref={(el) => (iconsRef.current[3] = el)}><img src={PresentationIcon} alt="success icon" /></span>
					<span className="floting-icon-5" ref={(el) => (iconsRef.current[4] = el)}><img src={CareerIcon} alt="success icon" /></span>
					<span className="floting-icon-6" ref={(el) => (iconsRef.current[5] = el)}><img src={SearchPropleIcon} alt="success icon" /></span>
					<span className="floting-icon-7" ref={(el) => (iconsRef.current[6] = el)}><img src={writingNotesIcon} alt="success icon" /></span>
					<span className="floting-icon-8" ref={(el) => (iconsRef.current[7] = el)}><img src={idCardIcon} alt="success icon" /></span>
					{/* floating icons */}
				</div>
			</section>
			{/* ----------- empower HR section ------------ */}

			{/*------------problem-solution-section------------*/}
			<section className="problem-solution-section">
				<div className="container">
					<div className="hero-content text-center">
						<h2 className="text-heading">
							Turn HR Road Blocks into Seamless Success with <span className="primary-text-color"> Symplora
							</span>
						</h2>
					</div>
					<div className="card-wrapper">
						<div className="outer-section flex align-center">
							<div className="card-chip">
								<div className="inner-section flex align-center">
									<img src={thinkingIcon} />
									<span className="text-subheading fw-600 text-transform-uppercase">Problem</span>
								</div>
							</div>
							<div className="card-chip unset">
								<div className="inner-section flex align-center bg-blue">
									<img src={idea} />
									<span className="text-subheading fw-600 text-transform-uppercase">Solution</span>
								</div>
							</div>
						</div>
						<div ref={el => PScardsRef.current[0] = el} className="card flex align-center space-between">
							<div className="heading">
								<span className="fw-700 text-heading-1">Reduce Costs
									and Save Time</span>
							</div>
							<div className="card-body flex align-center">
								<div className="card-content subheading fw-500">
									<p>Manual HR tasks eat up valuable resources and increase labor costs.</p>
								</div>
								<div className="flex"><img src={cardRightArrow} /></div>
								<div className="card-content subheading fw-500">
									<p>Automating HR processes can slash manual task time by up to 40%, saving companies with 1,000 employees around $50,000 annually.</p>
								</div>
							</div>
						</div>
						<div ref={el => PScardsRef.current[1] = el} className="card flex align-center space-between">
							<div className="heading">
								<span className="fw-700 text-heading-1">Minimize Payroll Errors</span>
							</div>
							<div className="card-body flex align-center">
								<div className="card-content subheading fw-500">
									<p>Payroll mistakes lead to financial losses and employee dissatisfaction.</p>
								</div>
								<div className="flex"><img src={cardRightArrow} /></div>
								<div className="card-content subheading fw-500">
									<p>Automating HRMS cuts payroll errors by 50%, avoiding costly corrections and saving thousands a year.</p>
								</div>
							</div>
						</div>
						<div ref={el => PScardsRef.current[2] = el} className="card flex align-center space-between">
							<div className="heading performance">
								<span className="fw-700 text-heading-1">Boost Productivity and Performance</span>
							</div>
							<div className="card-body flex align-center">
								<div className="card-content subheading fw-500">
									<p>Tedious, time-consuming tasks leave little time for strategic HR planning.</p>
								</div>
								<div className="flex"><img src={cardRightArrow} /></div>
								<div className="card-content subheading fw-500">
									<p>Automating payroll, leave, and onboarding saves HR teams 25-30 hours/month -more time for strategy, less for busywork!</p>
								</div>
							</div>
						</div>
						<div ref={el => PScardsRef.current[3] = el} className="card flex align-center space-between">
							<div className="heading">
								<span className="fw-700 text-heading-1">Empower  Employees and Free Up HR</span>
							</div>
							<div className="card-body flex align-center">
								<div className="card-content subheading fw-500">
									<p>Routine inquiries bog down HR teams, reducing their capacity for strategic tasks.</p>
								</div>
								<div className="flex"><img src={cardRightArrow} /></div>
								<div className="card-content subheading fw-500">
									<p>Employee self-service (ESS) frees up 2 hours per employee per month, resulting in $20,000 saved annually for medium-sized businesses.</p>
								</div>
							</div>
						</div>
						<div ref={el => PScardsRef.current[4] = el} className="card flex align-center space-between">
							<div className="heading">
								<span className="fw-700 text-heading-1">Exceptional ROI</span>
							</div>
							<div className="card-body flex align-center">
								<div className="card-content subheading fw-500">
									<p>Traditional HR systems fail to deliver measurable returns.</p>
								</div>
								<div className="flex"><img src={cardRightArrow} /></div>
								<div className="card-content subheading fw-500">
									<p>Companies automating HRMS see an ROI of 100-300%, with annual savings exceeding $50,000, directly impacting the bottom line.</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			{/*------------problem-solution-section------------*/}

			{/*------------Decisions-section------------*/}
			<section className="decisions-section">
				<div className="container">
					<h3 className="primary-text-color text-center fw-700 text-heading heading">Data-Driven Results For Smarter HR Decisions</h3>
					<p className="sub-heading text-subheading text-center">Discover how Symplora helps businesses save thousands annually with tools that make HR smarter, faster, and more effective.</p>
					<div className="cards-wrapper flex">
						<div className="card" ref={el => decisionsCardsRef.current[0] = el}>
							<div className="flex align-center justify-center">
								<span className="fw-700 discount">40%</span>
								<span className="fw-500 sub-heading">Reduction in Manual HR Tasks</span>
							</div>
							<div className="card-content text-body-1 text-center fw-500"><p>Automating repetitive tasks saves companies with 1,000 employees up to $50,000 annually.</p></div>
						</div>
						<div className="card" ref={el => decisionsCardsRef.current[1] = el}>
							<div className="flex align-center justify-center">
								<span className="fw-700 discount">50%</span>
								<span className="fw-500 sub-heading">Fewer Payroll Errors</span>
							</div>
							<div className="card-content text-body-1 text-center fw-500"><p>Prevent costly corrections and save $40,000 annually while improving employee satisfaction.</p></div>
						</div>
						<div className="card" ref={el => decisionsCardsRef.current[2] = el}>
							<p className="fw-700 discount text-center">25-30</p>
							<p className="fw-500 sub-heading text-center">Hours Saved Per Month</p>
							<div className="card-content text-body-1 text-center fw-500"><p>Automation of tasks like onboarding and payroll translates to $30,000 saved annually in productivity.</p></div>
						</div>
						<div className="card" ref={el => decisionsCardsRef.current[3] = el}>
							<p className="fw-700 discount text-center">10-15%</p>
							<p className="fw-500 sub-heading text-center">Boost in Productivity</p>
							<div className="card-content text-body-1 text-center fw-500"><p>Real-time analytics enable smarter decisions, increasing organizational efficiency.</p></div>
						</div>
						<div className="card" ref={el => decisionsCardsRef.current[4] = el}>
							<div className="flex align-center justify-center">
								<span className="fw-700 discount">50%</span>
								<span className="fw-500 sub-heading">Faster Time-to-Hire</span>
							</div>
							<div className="card-content text-body-1 text-center fw-500"><p>Reduce recruitment delays, prevent revenue loss, and keep teams fully staffed.</p></div>
						</div>
					</div>
					<div className="button-wrapper flex justify-center">
						<button className="btn btn--regular btn--primary">
							See How Symplora Saves Time and Money
						</button>
					</div>
				</div>
			</section>
			{/*------------Decisions-section------------*/}

			{/*------------ATA-section------------*/}
			<section className="ata-section">
				<div className="container">
					<div className="heading-sec">
						<h3 className="text-center fw-700 text-heading heading">Reimagine Recruitment With Symplora's Next-Gen <span className="primary-text-color">ATS</span></h3>
					</div>
					<div className="sub-heading-sec">
						<p className="sub-heading text-subheading text-center">Say goodbye to tedious hiring processes. With Symplora's AI-powered ATS, discover talent faster, simplify workflows, and make smarter hiring decisions.</p>
					</div>
					<div className="dasbord-bg-img flex">
						<img src={dashboardats} />
					</div>
					<div className="ats-card-wrapper flex justify-center">
						<div className="card flex" ref={el => atsCardsRef.current[0] = el}>
							<img src={aiPowered} />
							<span className="text-body fw-700">AI-Powered Insights</span>
							<p className="text-body-1">Automate CV parsing and job description generation tailored to roles.</p>
						</div>
						<div className="card flex" ref={el => atsCardsRef.current[1] = el}>
							<img src={click} />
							<span className="text-body fw-700">One-Click Efficiency</span>
							<p className="text-body-1">Post job openings to multiple platforms instantly.</p>
						</div>
						<div className="card flex" ref={el => atsCardsRef.current[2] = el}>
							<img src={calender} />
							<span className="text-body fw-700">Seamless Scheduling</span>
							<p className="text-body-1">Automate interviews and feedback loops for faster decisions.</p>
						</div>
						<div className="card flex" ref={el => atsCardsRef.current[3] = el}>
							<img src={offer} />
							<span className="text-body fw-700">Integrated Offers</span>
							<p className="text-body-1">Simplify the offer approval process with built-in digital signatures.</p>
						</div>
						<div className="card flex" ref={el => atsCardsRef.current[4] = el}>
							<img src={analysis} />
							<span className="text-body fw-700">Real-Time Analytics</span>
							<p className="text-body-1">Track hiring progress with actionable insights.</p>
						</div>
					</div>
					<div className="button-wrapper flex justify-center">
						<button className="btn btn--regular btn--primary">
							Learn More about ATS
						</button>
					</div>
				</div>
			</section>
			{/*------------ATS-section------------*/}


			{/*------------Journey-With-Product------------*/}
			<section className="welcome-section">
				<div className="container">
					<div className="heading-sec">
						<h3 className="text-center fw-700 text-heading heading">Your Journey With Symplora Is<span className="primary-text-color">Just Getting Started…</span></h3>
					</div>
					<p className="text-center text-subheading">Symplora doesn't stop at just ATS. We're building a suite of powerful modules to handle everything from employee engagement to payroll management, giving you a complete solution for your HR needs</p>
					<div className="content">
						<div className="card-wrapper flex">
							<div ref={el => journeyCardRef.current[0] = el} className={`card flex justify-center align-center ${hoveredCard === 1 ? "visible" : "hide"
								}`} onMouseOver={() => handleMouseEnter(1)}
							>
								<div className="icon flex justify-center align-center">
									<svg width="37" height="36" viewBox="0 0 37 36" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path d="M28.6123 9.86997C28.3453 9.86997 28.0783 9.77697 27.8638 9.58498C25.2718 7.27349 21.9463 5.99999 18.5009 5.99999C15.0554 5.99999 11.7299 7.27349 9.1379 9.58498C8.6744 9.99597 7.9619 9.95697 7.5494 9.49348C7.1354 9.02998 7.1759 8.31748 7.6409 7.90498C10.6454 5.22599 14.5019 3.75 18.5009 3.75C22.4998 3.75 26.3563 5.22599 29.3608 7.90498C29.8258 8.31898 29.8663 9.02998 29.4523 9.49348C29.2303 9.74248 28.9213 9.86997 28.6123 9.86997Z" fill="#7703FC" />
										<path d="M30.1266 15.5863C29.7681 15.5863 29.4156 15.4153 29.1981 15.0973C26.7591 11.5453 22.7601 9.42431 18.5002 9.42431C14.2402 9.42431 10.2412 11.5453 7.8022 15.0988C7.4512 15.6103 6.75371 15.7453 6.23771 15.3898C5.72621 15.0388 5.59571 14.3383 5.94821 13.8268C8.8057 9.65981 13.4977 7.17432 18.5002 7.17432C23.5026 7.17432 28.1946 9.66131 31.0521 13.8253C31.4031 14.3368 31.2726 15.0373 30.7626 15.3883C30.5676 15.5233 30.3441 15.5863 30.1266 15.5863Z" fill="#7703FC" />
										<path d="M15.6762 32.2499C15.3912 32.2499 15.1047 32.1419 14.8857 31.9259C14.6877 31.7309 10.0332 27.0809 10.0332 22.5659C10.0332 17.8545 13.8312 14.022 18.5022 14.022C23.1731 14.022 26.9711 17.8545 26.9711 22.5659C26.9711 23.1869 26.4671 23.6909 25.8461 23.6909C25.2251 23.6909 24.7211 23.1869 24.7211 22.5659C24.7211 19.0965 21.9327 16.272 18.5022 16.272C15.0717 16.272 12.2832 19.095 12.2832 22.5659C12.2832 26.1389 16.4277 30.2849 16.4682 30.3254C16.9092 30.7634 16.9137 31.4744 16.4772 31.9169C16.2567 32.1389 15.9672 32.2499 15.6762 32.2499Z" fill="#7703FC" />
										<path d="M21.325 32.2499C19.108 32.2499 13.972 28.1414 13.4755 23.5649C13.2985 21.9149 13.807 20.2844 14.8705 19.0934C15.8125 18.0374 17.092 17.4524 18.475 17.4449C19.8295 17.4374 21.106 17.9624 22.069 18.9209C23.044 19.8899 23.581 21.1844 23.581 22.5644V23.1344C23.581 24.4019 24.598 25.4339 25.8459 25.4339C27.0939 25.4339 28.1109 24.4019 28.1109 23.1344V22.9349C28.1109 17.6189 24.172 13.1955 19.144 12.8685C16.4575 12.6855 13.9255 13.605 11.9755 15.432C10.018 17.2664 8.89452 19.8659 8.89452 22.5629C8.89452 24.8174 9.67602 27.0134 11.092 28.7474C11.485 29.2289 11.413 29.9369 10.933 30.3299C10.4515 30.7229 9.74502 30.6524 9.34902 30.1709C7.60603 28.0364 6.64453 25.3334 6.64453 22.5629C6.64453 19.2449 8.02753 16.047 10.4365 13.7895C12.8485 11.5305 16.006 10.41 19.2895 10.6215C25.498 11.028 30.3594 16.4355 30.3594 22.9334V23.1329C30.3594 25.6409 28.3329 27.6824 25.8444 27.6824C23.356 27.6824 21.3295 25.6424 21.3295 23.1329V22.5629C21.3295 21.7859 21.028 21.0584 20.482 20.5139C19.951 19.9844 19.2475 19.6934 18.502 19.6934C18.496 19.6934 18.4915 19.6934 18.487 19.6934C17.542 19.6979 16.912 20.1839 16.549 20.5904C15.9175 21.2984 15.6055 22.3184 15.7135 23.3219C16.0855 26.7659 20.23 29.9999 21.325 29.9999C21.946 29.9999 22.45 30.5039 22.45 31.1249C22.45 31.7459 21.946 32.2499 21.325 32.2499Z" fill="#7703FC" />
										<path d="M24.6442 30.5386C21.3202 30.5386 17.3047 26.7271 17.3047 21.9946C17.3047 21.3736 17.8087 20.8696 18.4297 20.8696C19.0507 20.8696 19.5547 21.3736 19.5547 21.9946C19.5547 25.4686 22.6342 28.2886 24.6442 28.2886C25.2652 28.2886 25.7692 28.7926 25.7692 29.4136C25.7692 30.0346 25.2652 30.5386 24.6442 30.5386Z" fill="#7703FC" />
										<path d="M35.3755 12.5219C34.7545 12.5219 34.2505 12.018 34.2505 11.397V4.12498C34.2505 3.09149 33.409 2.24999 32.3755 2.24999H25.1035C24.4825 2.24999 23.9785 1.74599 23.9785 1.125C23.9785 0.503998 24.4825 0 25.1035 0H32.3755C34.651 0 36.5005 1.85099 36.5005 4.12498V11.397C36.5005 12.018 35.9965 12.5219 35.3755 12.5219Z" fill="#7703FC" />
										<path d="M1.625 12.5219C1.004 12.5219 0.5 12.018 0.5 11.397V4.12498C0.5 1.85099 2.34949 0 4.62498 0H11.897C12.518 0 13.0219 0.503998 13.0219 1.125C13.0219 1.74599 12.518 2.24999 11.897 2.24999H4.62498C3.59149 2.24999 2.74999 3.09149 2.74999 4.12498V11.397C2.74999 12.018 2.24599 12.5219 1.625 12.5219Z" fill="#7703FC" />
										<path d="M32.3755 36H25.1035C24.4825 36 23.9785 35.496 23.9785 34.875C23.9785 34.254 24.4825 33.75 25.1035 33.75H32.3755C33.409 33.75 34.2505 32.9085 34.2505 31.875V24.603C34.2505 23.982 34.7545 23.478 35.3755 23.478C35.9965 23.478 36.5005 23.982 36.5005 24.603V31.875C36.5005 34.149 34.651 36 32.3755 36Z" fill="#7703FC" />
										<path d="M11.897 36H4.62498C2.34949 36 0.5 34.149 0.5 31.875V24.603C0.5 23.982 1.004 23.478 1.625 23.478C2.24599 23.478 2.74999 23.982 2.74999 24.603V31.875C2.74999 32.9085 3.59149 33.75 4.62498 33.75H11.897C12.518 33.75 13.0219 34.254 13.0219 34.875C13.0219 35.496 12.518 36 11.897 36Z" fill="#7703FC" />
									</svg>
								</div>
								<span className="text-subheading fw-600 text-center">Digital Signatures</span>
							</div>
							<div className="d-none visible-for-mobile">
								<div className="paragraph-wrapper flex justify-center align-center">
									<span
										className={`text-subheading text-center fw-500 `}
									>
										Simplify document approvals with integrated e-signatures, making onboarding and compliance a breeze.
									</span>
								</div>
							</div>
							<div ref={el => journeyCardRef.current[1] = el} className={`card flex justify-center align-center ${hoveredCard === 2 ? "visible" : "hide"
								}`} onMouseEnter={() => handleMouseEnter(2)}
							>
								<div className="icon flex justify-center align-center">
									<svg width="36" height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path fill-rule="evenodd" clip-rule="evenodd" d="M18 0.735352C17.4189 0.735352 16.8377 0.764152 16.2591 0.823552C15.8846 0.862252 15.5777 1.15205 15.5023 1.53905L15.0737 3.72875C14.3571 3.87365 13.6491 4.07345 12.9591 4.32455L11.5466 2.65325C11.2963 2.35805 10.8926 2.26715 10.5506 2.43005C9.492 2.93585 8.48057 3.54785 7.53343 4.25795C7.22743 4.48745 7.10143 4.89965 7.22057 5.27405L7.89171 7.39535C7.33971 7.89845 6.822 8.44205 6.34286 9.02165L4.32257 8.31695C3.966 8.19185 3.57343 8.32415 3.35486 8.64545C2.67857 9.63995 2.09571 10.702 1.614 11.8135C1.45886 12.1726 1.54543 12.5965 1.82657 12.8593L3.41829 14.3425C3.17914 15.067 2.98886 15.8104 2.85086 16.5628L0.765428 17.0128C0.396857 17.092 0.120857 17.4142 0.084 17.8075C0.0282858 18.415 0 19.0252 0 19.6354C0 20.1322 0.384 20.5354 0.857143 20.5354C1.33029 20.5354 1.71429 20.1322 1.71429 19.6354C1.71429 19.3033 1.72286 18.9721 1.74086 18.6409L3.768 18.2026C4.11943 18.127 4.38943 17.8291 4.44343 17.4574C4.596 16.4125 4.85743 15.3883 5.22343 14.4046C5.35371 14.0536 5.26029 13.654 4.992 13.4038L3.44571 11.9629C3.73029 11.3689 4.04743 10.7938 4.39457 10.2385C4.39543 10.2385 6.35829 10.9234 6.35829 10.9234C6.69857 11.0422 7.07314 10.9261 7.29771 10.6318C7.92686 9.80735 8.64 9.05855 9.42514 8.39795C9.70543 8.16215 9.816 7.76885 9.70286 7.41155L9.05057 5.34965C9.57943 4.98425 10.1271 4.65215 10.6929 4.35335L12.0651 5.97695C12.3034 6.25865 12.684 6.35675 13.0174 6.21995C13.9551 5.83565 14.9306 5.56115 15.9257 5.40095C16.2797 5.34425 16.5634 5.06075 16.6354 4.69175L17.0529 2.56325C17.6846 2.52455 18.3154 2.52455 18.9471 2.56325L19.3646 4.69175C19.4366 5.06075 19.7203 5.34425 20.0743 5.40095C21.0694 5.56115 22.0449 5.83565 22.9817 6.21995C23.316 6.35675 23.6966 6.25865 23.9349 5.97695L25.3071 4.35335C25.8729 4.65215 26.4206 4.98515 26.9494 5.34965C26.9494 5.35055 26.2971 7.41155 26.2971 7.41155C26.184 7.76885 26.2946 8.16215 26.5749 8.39795C27.36 9.05855 28.0731 9.80735 28.7023 10.6318C28.9269 10.9261 29.3014 11.0422 29.6417 10.9234L31.6054 10.2385C31.9534 10.7938 32.2697 11.3689 32.5543 11.9629L31.008 13.4038C30.7397 13.654 30.6463 14.0536 30.7766 14.4046C31.1426 15.3883 31.404 16.4125 31.5566 17.4574C31.6106 17.8291 31.8806 18.127 32.232 18.2026L34.2591 18.6409C34.2771 18.9721 34.2857 19.3033 34.2857 19.6354C34.2857 20.1322 34.6697 20.5354 35.1429 20.5354C35.616 20.5354 36 20.1322 36 19.6354C36 19.0252 35.9717 18.415 35.916 17.8075C35.8791 17.4142 35.6031 17.092 35.2346 17.0128L33.1491 16.5628C33.0111 15.8104 32.8209 15.067 32.5817 14.3425L34.1734 12.8593C34.4546 12.5965 34.5411 12.1726 34.386 11.8135C33.9043 10.702 33.3214 9.63995 32.6451 8.64545C32.4266 8.32415 32.034 8.19185 31.6774 8.31695L29.6571 9.02165C29.178 8.44205 28.6603 7.89845 28.1083 7.39535L28.7794 5.27405C28.8986 4.89965 28.7726 4.48745 28.4666 4.25795C27.5194 3.54785 26.508 2.93585 25.4494 2.43005C25.1074 2.26715 24.7037 2.35805 24.4534 2.65325L23.0409 4.32455C22.3509 4.07345 21.6429 3.87365 20.9263 3.72875L20.4977 1.53905C20.4223 1.15205 20.1154 0.862252 19.7409 0.823552C19.1623 0.764152 18.5811 0.735352 18 0.735352ZM18 7.93535C11.85 7.93535 6.85714 13.1779 6.85714 19.6354C6.85714 20.1322 7.24114 20.5354 7.71429 20.5354C8.18743 20.5354 8.57143 20.1322 8.57143 19.6354C8.57143 14.1715 12.7963 9.73535 18 9.73535C23.2037 9.73535 27.4286 14.1715 27.4286 19.6354C27.4286 20.1322 27.8126 20.5354 28.2857 20.5354C28.7589 20.5354 29.1429 20.1322 29.1429 19.6354C29.1429 13.1779 24.15 7.93535 18 7.93535ZM18 13.3354C16.1074 13.3354 14.5714 14.9482 14.5714 16.9354C14.5714 17.434 14.6674 17.9101 14.8423 18.3421C14.478 18.5356 14.1163 18.7948 13.7914 19.2997C13.2977 20.0665 12.8571 21.5839 12.8571 25.0354C12.8571 25.5322 13.2411 25.9354 13.7143 25.9354H17.1429V32.2354H10.9089C10.7331 31.168 10.4777 30.5199 10.2069 30.0996C9.882 29.5947 9.522 29.3356 9.15771 29.1412C9.33257 28.7101 9.42857 28.234 9.42857 27.7354C9.42857 25.7482 7.89257 24.1354 6 24.1354C4.10743 24.1354 2.57143 25.7482 2.57143 27.7354C2.57143 28.234 2.66743 28.7101 2.84229 29.1412C2.478 29.3356 2.11629 29.5938 1.79143 30.0996C1.29771 30.8664 0.857143 32.3839 0.857143 35.8354C0.857143 36.3321 1.24114 36.7354 1.71429 36.7354H10.2857C10.7597 36.7354 11.1429 36.3321 11.1429 35.8354C11.1429 35.1649 11.1249 34.569 11.094 34.0354H24.9043C24.8734 34.569 24.8571 35.1649 24.8571 35.8354C24.8571 36.3321 25.2411 36.7354 25.7143 36.7354H34.2857C34.7597 36.7354 35.1429 36.3321 35.1429 35.8354C35.1429 32.3839 34.7006 30.8664 34.2069 30.0996C33.882 29.5947 33.522 29.3356 33.1577 29.1412C33.3326 28.7101 33.4286 28.234 33.4286 27.7354C33.4286 25.7482 31.8926 24.1354 30 24.1354C28.1074 24.1354 26.5714 25.7482 26.5714 27.7354C26.5714 28.234 26.6674 28.7101 26.8423 29.1412C26.478 29.3356 26.1163 29.5938 25.7914 30.0996C25.5206 30.5199 25.2669 31.1688 25.0911 32.2354H18.8571V25.9354H22.2857C22.7597 25.9354 23.1429 25.5322 23.1429 25.0354C23.1429 21.5839 22.7006 20.0665 22.2069 19.2997C21.882 18.7948 21.522 18.5356 21.1577 18.3421C21.3326 17.9101 21.4286 17.434 21.4286 16.9354C21.4286 14.9482 19.8926 13.3354 18 13.3354ZM18 15.1354C18.9463 15.1354 19.7143 15.9418 19.7143 16.9354C19.7143 17.929 18.9463 18.7354 18 18.7354C17.0537 18.7354 16.2857 17.929 16.2857 16.9354C16.2857 15.9418 17.0537 15.1354 18 15.1354ZM15.9206 19.7974C16.4974 20.26 17.2183 20.5354 18 20.5354C18.7817 20.5354 19.5026 20.26 20.0794 19.7974C20.088 19.801 20.0957 19.8055 20.1043 19.8091C20.328 19.9198 20.5834 19.9909 20.7874 20.3068C21.1466 20.8657 21.372 21.925 21.4183 24.1354H14.58C14.6263 21.925 14.8517 20.8657 15.2109 20.3068C15.4149 19.9909 15.672 19.9198 15.8957 19.8091C15.9043 19.8055 15.912 19.801 15.9206 19.7974ZM6 25.9354C6.94629 25.9354 7.71429 26.7418 7.71429 27.7354C7.71429 28.729 6.94629 29.5354 6 29.5354C5.05371 29.5354 4.28571 28.729 4.28571 27.7354C4.28571 26.7418 5.05371 25.9354 6 25.9354ZM30 25.9354C30.9463 25.9354 31.7143 26.7418 31.7143 27.7354C31.7143 28.729 30.9463 29.5354 30 29.5354C29.0537 29.5354 28.2857 28.729 28.2857 27.7354C28.2857 26.7418 29.0537 25.9354 30 25.9354ZM3.92057 30.5974C4.49743 31.06 5.21829 31.3354 6 31.3354C6.78171 31.3354 7.50257 31.06 8.07943 30.5974C8.088 30.601 8.09571 30.6055 8.10429 30.6091C8.328 30.7198 8.58343 30.7908 8.78743 31.1067C9.14657 31.6656 9.372 32.725 9.41829 34.9354C9.41829 34.9362 2.58 34.9354 2.58 34.9354C2.62629 32.725 2.85171 31.6656 3.21086 31.1067C3.41486 30.7908 3.672 30.7198 3.89571 30.6091C3.90429 30.6055 3.912 30.601 3.92057 30.5974ZM27.9206 30.5974C28.4974 31.06 29.2183 31.3354 30 31.3354C30.7817 31.3354 31.5026 31.06 32.0794 30.5974C32.088 30.601 32.0957 30.6055 32.1043 30.6091C32.328 30.7198 32.5834 30.7908 32.7874 31.1067C33.1466 31.6656 33.372 32.725 33.4183 34.9354H26.58C26.6263 32.725 26.8517 31.6656 27.2109 31.1067C27.4149 30.7908 27.672 30.7198 27.8957 30.6091C27.9043 30.6055 27.912 30.601 27.9206 30.5974Z" fill="#7703FC" />
									</svg>
								</div>
								<span className="text-subheading fw-600">Core HRMS</span>
							</div>
							<div className="d-none visible-for-mobile">
								<div className="paragraph-wrapper flex justify-center align-center">
									<span
										className={`text-subheading text-center  fw-500`}
									>
										A centralized hub for all HR data, giving you unmatched control and insights.
									</span>

								</div>
							</div>
							<div ref={el => journeyCardRef.current[2] = el} className={`card flex justify-center align-center ${hoveredCard === 3 ? "visible" : "hide"
								}`} onMouseEnter={() => handleMouseEnter(3)}
							>
								<div className="icon flex justify-center align-center">
									<svg width="36" height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path d="M18 14.7217C20.9271 14.7217 23.3085 12.2143 23.3085 9.13225C23.3085 6.05024 20.9271 3.54285 18 3.54285C15.0729 3.54285 12.6915 6.05024 12.6915 9.13225C12.6915 12.2143 15.0729 14.7217 18 14.7217ZM18 4.7656C20.2868 4.7656 22.1472 6.72444 22.1472 9.13225C22.1472 11.5401 20.2868 13.4989 18 13.4989C15.7132 13.4989 13.8527 11.5401 13.8527 9.13225C13.8527 6.72444 15.7132 4.7656 18 4.7656ZM18.8585 10.6627C18.9049 10.6062 18.95 10.5273 18.932 10.3713C18.9152 10.2256 18.8759 9.88454 17.9102 9.71756C16.3581 9.44917 16.0854 8.52057 16.061 7.99089C16.0212 7.12809 16.5634 6.40262 17.4194 6.15777V5.98208C17.4194 5.64445 17.6793 5.3707 18 5.3707C18.3207 5.3707 18.5806 5.64445 18.5806 5.98208V6.15227C19.133 6.30396 19.6507 6.68959 19.9273 7.38319C20.0515 7.69453 19.9124 8.05295 19.6168 8.18363C19.3213 8.31423 18.9808 8.16804 18.8566 7.8567C18.6293 7.2869 18.0663 7.2548 17.7701 7.32572C17.6361 7.35767 17.2008 7.49591 17.2209 7.93174C17.2264 8.04966 17.2408 8.36284 18.0984 8.51102C19.3096 8.72049 19.978 9.29679 20.0848 10.2239C20.1387 10.6915 20.0185 11.1199 19.7369 11.4627C19.4687 11.789 19.0555 12.0232 18.5806 12.1283V12.2824C18.5806 12.6201 18.3207 12.8938 18 12.8938C17.6793 12.8938 17.4194 12.6201 17.4194 12.2824V12.1179C16.6701 11.9278 16.0992 11.3764 15.9199 10.6193C15.8424 10.2917 16.0318 9.9599 16.3429 9.8782C16.6542 9.79712 16.9691 9.99597 17.0467 10.3236C17.1629 10.8143 17.6588 10.9779 18.0479 10.9671C18.3903 10.9583 18.7161 10.8361 18.8585 10.6627ZM28.8245 21.6249C28.7561 21.6249 28.688 21.6261 28.6201 21.6281V5.58873C28.6201 3.28386 27.0587 0.810932 24.7344 0.803367L3.96131 0.735428C3.95136 0.735352 3.94164 0.735352 3.93177 0.735352C1.76378 0.735352 0 2.59247 0 4.87519C0 5.60325 0.182395 6.31978 0.527516 6.94728C0.631306 7.13604 0.822774 7.25228 1.02999 7.25228H7.37993V29.9771C7.37993 32.2533 8.90332 34.6917 11.1799 34.7592C11.208 34.7637 11.2365 34.7668 11.2657 34.7669L24.0404 34.8059C25.3108 36.0049 26.988 36.7354 28.8245 36.7354C32.7811 36.7354 36 33.3461 36 29.1801C36 25.0141 32.781 21.6249 28.8245 21.6249ZM34.8387 29.1802C34.8387 30.5535 34.42 31.8251 33.7118 32.8638C33.2173 31.3932 32.1476 30.2292 30.7972 29.6467C31.3725 29.0867 31.7336 28.2861 31.7336 27.398C31.7336 25.7089 30.4286 24.3349 28.8245 24.3349C27.2204 24.3349 25.9154 25.7089 25.9154 27.398C25.9154 28.2861 26.2764 29.0867 26.8518 29.6467C25.5014 30.2292 24.4317 31.3932 23.9371 32.8638C23.2289 31.8251 22.8102 30.5535 22.8102 29.1802C22.8102 25.6884 25.5082 22.8476 28.8245 22.8476C32.1407 22.8476 34.8387 25.6883 34.8387 29.1802ZM27.0766 27.3981C27.0766 26.3833 27.8607 25.5577 28.8245 25.5577C29.7883 25.5577 30.5723 26.3833 30.5723 27.3981C30.5723 28.4129 29.7883 29.2385 28.8245 29.2385C27.8607 29.2385 27.0766 28.4129 27.0766 27.3981ZM1.38687 6.02953C1.23859 5.66691 1.16129 5.27365 1.16129 4.87519C1.16129 3.26674 2.40402 1.95825 3.93155 1.9581L3.95506 1.95817C5.84572 1.97147 7.37993 3.59497 7.37993 5.58873V6.02961L1.38687 6.02953ZM11.316 33.5423C11.3005 33.5409 11.285 33.5397 11.2692 33.5396C9.66157 33.5344 8.54115 31.6579 8.54115 29.9771V5.58873C8.54115 4.15117 7.94446 2.85766 6.99823 1.96811L24.7306 2.02611C26.3383 2.03139 27.4587 3.90792 27.4587 5.58873V21.7628C24.4167 22.3825 22.0539 25.0315 21.6962 28.3135H14.2052C13.9976 28.3135 13.8059 28.4302 13.7021 28.6196C13.5984 28.809 13.5986 29.0421 13.7027 29.2313C13.7683 29.3507 13.8263 29.4408 13.8729 29.5133C13.993 29.7 14.0379 29.7699 14.0379 30.6271C14.0379 31.6023 12.8102 33.5016 11.316 33.5423ZM15.1992 30.6271C15.1992 30.1181 15.1788 29.7857 15.1319 29.5363H21.657C21.7237 31.0401 22.2097 32.4304 22.9947 33.5801L13.8264 33.5521C14.6667 32.6881 15.1992 31.5261 15.1992 30.6271ZM24.865 33.9408C25.2064 31.9371 26.8597 30.4612 28.8245 30.4612C30.7892 30.4612 32.4425 31.9371 32.784 33.9408C31.7252 34.9183 30.3399 35.5127 28.8245 35.5127C27.309 35.5127 25.9237 34.9182 24.865 33.9408ZM10.203 17.5656C10.203 17.228 10.4629 16.9542 10.7836 16.9542H15.322C15.6427 16.9542 15.9026 17.228 15.9026 17.5656C15.9026 17.9032 15.6427 18.177 15.322 18.177H10.7836C10.4629 18.177 10.203 17.9032 10.203 17.5656ZM10.1318 20.8736C10.1318 20.536 10.3917 20.2622 10.7124 20.2622H17.8866C18.2072 20.2622 18.4672 20.536 18.4672 20.8736C18.4672 21.2112 18.2072 21.485 17.8866 21.485H10.7124C10.3917 21.485 10.1318 21.2111 10.1318 20.8736ZM22.1131 24.2909H10.7836C10.4629 24.2909 10.203 24.0172 10.203 23.6796C10.203 23.3419 10.4629 23.0682 10.7836 23.0682H22.1131C22.4338 23.0682 22.6938 23.3419 22.6938 23.6796C22.6938 24.0172 22.4338 24.2909 22.1131 24.2909Z" fill="#7703FC" />
									</svg>
								</div>
								<span className="text-subheading fw-600">Payroll (India, USA, UK)</span>
							</div>
							<div className="d-none visible-for-mobile">
								<div className="paragraph-wrapper flex justify-center align-center">
									<span
										className={`text-subheading text-center fw-500 `}
									>
										Automated payroll solutions with compliance for multiple geographies.
									</span>
								</div>
							</div>
							<div ref={el => journeyCardRef.current[3] = el} className={`card flex justify-center align-center ${hoveredCard === 4 ? "visible" : "hide"
								}`} onMouseEnter={() => handleMouseEnter(4)}
							>
								<div className="icon flex justify-center align-center">
									<svg width="36" height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path d="M27.6225 23.103C29.844 23.103 31.1863 25.4136 30.0273 27.1782C31.5667 27.6533 32.6521 29.0222 32.6521 30.592V31.917C32.6521 32.2584 32.3601 32.5342 31.9985 32.5342H23.2497C22.8881 32.5342 22.5937 32.2584 22.5937 31.917V30.592C22.5937 29.0222 23.6791 27.6556 25.2185 27.1782C24.0611 25.4129 25.4033 23.103 27.6225 23.103ZM28.712 28.2358C28.3783 28.3694 28.0094 28.4413 27.6225 28.4413C27.2356 28.4413 26.8691 28.3686 26.5329 28.2358H26.3963C25.0263 28.2358 23.904 29.298 23.904 30.592V31.2997H31.3442V30.592C31.3442 29.298 30.2195 28.2358 28.8494 28.2358H28.712ZM28.6956 24.7608C27.7427 23.8585 26.106 24.5005 26.106 25.7729C26.106 26.5655 26.7857 27.2075 27.6225 27.2075C28.9606 27.2067 29.6559 25.667 28.6956 24.7608ZM27.6225 22.1481C23.7175 22.1481 20.5528 25.1348 20.5528 28.8229C20.5528 32.5111 23.7175 35.5 27.6225 35.5C31.5274 35.5 34.6921 32.5111 34.6921 28.8229C34.6921 25.1348 31.5274 22.1481 27.6225 22.1481ZM21.698 23.2273C24.9698 20.1371 30.2743 20.1371 33.5461 23.2273C36.818 26.3175 36.818 31.3275 33.5461 34.4177C30.2743 37.5079 24.9698 37.5079 21.698 34.4177C18.427 31.3283 18.427 26.3175 21.698 23.2273ZM8.37753 24.3398C7.03035 24.3398 6.35145 25.8857 7.30601 26.7857C7.58002 27.046 7.95956 27.206 8.37753 27.206C9.71571 27.206 10.411 25.6663 9.4507 24.7601C9.1775 24.4997 8.79796 24.3398 8.37753 24.3398ZM6.37926 23.8848C7.48514 22.8426 9.2732 22.8426 10.3766 23.8848C11.3017 24.7608 11.476 26.1252 10.7823 27.1782C12.3217 27.6556 13.4072 29.0222 13.4072 30.592V31.917C13.4072 32.2584 13.1151 32.5342 12.7536 32.5342H4.00473C3.64319 32.5342 3.35118 32.2584 3.35118 31.917V30.592C3.35118 29.0222 4.43661 27.6533 5.97601 27.1782C5.28238 26.1252 5.45415 24.7608 6.37926 23.8848ZM9.47033 28.2358C9.13414 28.3694 8.76525 28.4413 8.37835 28.4413C7.99309 28.4413 7.62501 28.3686 7.28883 28.2358H7.15469C5.7846 28.2358 4.65991 29.298 4.65991 30.592V31.2997H12.1001V30.592C12.1001 29.298 10.9754 28.2358 9.60529 28.2358H9.47033ZM8.37753 20.9105C13.0055 20.9105 16.7551 24.4534 16.7551 28.8229C16.7551 33.194 13.0055 36.7354 8.37753 36.7354C3.75198 36.7354 0 33.194 0 28.8229C0.000817959 24.4541 3.75198 20.9105 8.37753 20.9105ZM13.3769 24.1011C10.6179 21.4953 6.14042 21.4953 3.38144 24.1011C0.620013 26.7092 0.620013 30.9358 3.38144 33.544C6.14042 36.1498 10.6179 36.1498 13.3769 33.544C16.1383 30.9358 16.1383 26.7092 13.3769 24.1011ZM31.0792 18.5171H33.6762V15.0352H31.0792C30.7618 15.0352 30.4951 14.8181 30.4395 14.5315H30.4371C30.1148 12.9223 29.4449 11.4019 28.4731 10.0577C28.2948 9.80816 28.3341 9.47983 28.5517 9.27356V9.27124L30.388 7.53687L27.782 5.07785L25.9457 6.81222C25.7093 7.03549 25.3379 7.05094 25.0811 6.86244C24.3809 6.4159 23.6316 6.03272 22.8456 5.72602C22.0595 5.417 21.2342 5.18291 20.3762 5.02995C20.0629 4.9751 19.8429 4.71475 19.8429 4.4235V1.96988H16.1588V4.42273C16.1588 4.74024 15.906 5.00059 15.5813 5.03613C14.7396 5.19141 13.9257 5.42395 13.1536 5.72602C12.3561 6.0389 11.5954 6.42672 10.8862 6.88484C10.622 7.05326 10.2744 7.01617 10.056 6.81068V6.81299L8.21721 5.07862L5.61365 7.53764L7.44997 9.27202C7.68636 9.49528 7.70517 9.84602 7.50313 10.0886C7.03035 10.7499 6.62465 11.4576 6.29992 12.2C5.97519 12.9424 5.72489 13.7219 5.56294 14.5323C5.50486 14.8297 5.22921 15.036 4.92084 15.036V15.0383H2.32382V18.5156L7.96283 18.5179C6.82178 12.5723 11.6404 7.13669 18 7.13669C24.3621 7.13669 29.1807 12.5723 28.0396 18.5179H31.0792V18.5171ZM34.3305 19.7524H27.2241C26.7955 19.7524 26.4798 19.3669 26.591 18.9752C28.11 13.6408 23.8738 8.37354 18.0008 8.37354C12.617 8.37354 8.47324 12.8543 9.17832 17.8867C9.22739 18.239 9.30346 18.592 9.4008 18.942C9.5374 19.3731 9.20613 19.7524 8.77915 19.7524H1.67027C1.30873 19.7524 1.01672 19.4766 1.01672 19.1351V14.418C1.01672 14.0788 1.30873 13.8007 1.67027 13.8007H4.39244C4.74007 12.3769 5.33882 11.0218 6.15023 9.79349L4.22557 7.97568C3.97037 7.73464 3.97037 7.34296 4.22557 7.10193L7.7567 3.76683C8.01191 3.5258 8.42661 3.5258 8.68181 3.76683L10.6065 5.58464C11.9095 4.81518 13.3442 4.25199 14.8492 3.92366V1.35262C14.8492 1.01115 15.1437 0.735352 15.5052 0.735352H20.4972C20.8588 0.735352 21.1508 1.01115 21.1508 1.35262V3.92366C22.6583 4.25199 24.093 4.8175 25.3935 5.58387L27.3206 3.76606C27.5758 3.52503 27.9881 3.52503 28.2458 3.76606L31.7744 7.10115C32.0321 7.34219 32.0321 7.73387 31.7744 7.97491L29.8498 9.79271C30.6636 11.0234 31.2616 12.3792 31.61 13.8022L34.3297 13.7999C34.6913 13.7999 34.9833 14.078 34.9833 14.4172V19.1344C34.9841 19.4766 34.6921 19.7524 34.3305 19.7524ZM18 14.1398C17.8331 14.1398 17.6663 14.0804 17.5387 13.9606C16.3952 12.8814 14.5409 12.8814 13.3998 13.9606C12.2571 15.0383 12.2571 16.7897 13.3998 17.8697L18 22.2145L22.6027 17.8697C23.7453 16.7905 23.7453 15.0383 22.6027 13.9606C21.4591 12.879 19.5999 12.8829 18.4662 13.9583C18.3435 14.0734 18.1783 14.1398 18 14.1398ZM18 12.7075C19.6695 11.5271 22.0301 11.6692 23.5278 13.0861C25.1809 14.6474 25.1809 17.1791 23.5278 18.7427L18.4638 23.5255C18.2086 23.7666 17.7939 23.7666 17.5387 23.5255L12.4722 18.7427C10.8191 17.1791 10.8191 14.6474 12.4722 13.0861C13.9707 11.6716 16.3305 11.5271 18 12.7075Z" fill="#7703FC" />
									</svg>
								</div>
								<span className="text-subheading fw-600">Employee Pulse & Sentiment</span>
							</div>
							<div className="d-none visible-for-mobile">
								<div className="paragraph-wrapper flex justify-center align-center">
									<span
										className={`text-subheading text-center  fw-500`}
									>
										Real-time tools to track employee satisfaction and engagement, empowering you to act proactively.
									</span>
								</div>
							</div>
							<div ref={el => journeyCardRef.current[4] = el} className={`card flex justify-center align-center ${hoveredCard === 5 ? "visible" : "hide"
								}`} onMouseEnter={() => handleMouseEnter(5)}
							>
								<div className="icon flex justify-center align-center">
									<svg width="36" height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path fill-rule="evenodd" clip-rule="evenodd" d="M24.8531 0.941286C24.985 0.809424 25.1638 0.735347 25.3503 0.735352L28.3685 0.735421C28.7568 0.73543 29.0716 1.05023 29.0716 1.43855V2.52146C29.5695 2.67073 30.0461 2.86908 30.4957 3.11102L31.2613 2.34549C31.5359 2.07091 31.9811 2.07092 32.2557 2.34551L34.3899 4.47977C34.6644 4.75436 34.6644 5.19955 34.3899 5.47413L33.6243 6.23964C33.8663 6.68925 34.0647 7.16587 34.2139 7.66373H35.2969C35.6852 7.66373 36 7.97853 36 8.36685V11.3851C36 11.573 35.9248 11.753 35.7912 11.8851L35.7911 11.8852C35.6595 12.0153 35.4819 12.0883 35.2968 12.0883H34.2113C34.0617 12.5851 33.8633 13.0607 33.6214 13.5093L34.3899 14.2779C34.6644 14.5525 34.6644 14.9977 34.3899 15.2722L33.8741 15.788V27.3111C33.8741 28.8658 32.6139 30.126 31.0592 30.126H19.8934V32.5166H21.5784C22.9777 32.5166 24.1121 33.651 24.1121 35.0504V36.0322C24.1121 36.4205 23.7973 36.7353 23.409 36.7353H10.4715C10.0832 36.7353 9.76839 36.4205 9.76839 36.0322V35.0504C9.76839 33.651 10.9028 32.5166 12.3022 32.5166H13.9871V30.126H2.81487C1.26026 30.126 5.14984e-05 28.8657 5.14984e-05 27.3111V25.01C1.71997e-05 25.0071 0 25.0043 0 25.0014C0 24.9985 1.71997e-05 24.9957 5.14984e-05 24.9928V7.90963C5.14984e-05 6.35498 1.26026 5.09474 2.81487 5.09474H19.1329C19.1263 5.05606 19.123 5.01664 19.123 4.97688C19.123 4.7904 19.1971 4.61156 19.3289 4.4797L21.4631 2.3455C21.7377 2.07092 22.1829 2.07091 22.4575 2.34549L23.226 3.11401C23.6747 2.87211 24.1503 2.67362 24.6471 2.52402V1.43848C24.6471 1.25199 24.7212 1.07315 24.8531 0.941286ZM23.1131 3.99546L22.7994 4.62469C22.7315 4.59086 22.6696 4.54627 22.616 4.49266L21.9603 3.83704L20.8205 4.97688L21.4781 5.63451C21.5315 5.68795 21.576 5.74965 21.6098 5.81725C21.6965 5.99059 21.6903 6.15271 21.6745 6.24749C21.6663 6.29653 21.6542 6.33745 21.6431 6.36846C21.6374 6.38436 21.6316 6.39877 21.6261 6.41157C21.6233 6.418 21.6205 6.42412 21.6178 6.42991C21.6164 6.43281 21.6151 6.43564 21.6138 6.43839L21.6118 6.44248L21.6108 6.44448L21.6103 6.44547L21.61 6.44597C21.6099 6.44621 21.6098 6.44646 20.9809 6.13197L21.6098 6.44646C21.5989 6.46815 21.587 6.48928 21.5739 6.50974C21.1875 7.11634 20.9031 7.79372 20.7436 8.51803C20.6727 8.84038 20.387 9.06998 20.0569 9.06998H19.125V10.682H20.0588C20.3886 10.682 20.674 10.9112 20.7453 11.2331C20.9055 11.9563 21.1904 12.6327 21.5769 13.2383C21.6491 13.3513 21.6874 13.4825 21.6874 13.6166C21.6874 13.7239 21.6626 13.8055 21.6507 13.841C21.6433 13.8629 21.6358 13.8815 21.6295 13.8961C21.6263 13.9035 21.6232 13.9104 21.6202 13.9166C21.6188 13.9197 21.6173 13.9227 21.6159 13.9256C21.6152 13.927 21.6145 13.9284 21.6139 13.9298L21.6128 13.9319L21.6121 13.9334L21.612 13.9336C21.6119 13.9337 21.6118 13.9339 20.9842 13.6169L21.6118 13.9339C21.5782 14.0005 21.5342 14.0613 21.4814 14.114L20.8205 14.775L21.9603 15.9149L22.6213 15.2539C22.6981 15.1771 22.7917 15.1192 22.8946 15.0846L22.8948 15.0845C23.0964 15.0168 23.3178 15.044 23.497 15.1584C24.1027 15.545 24.779 15.8299 25.5023 15.99C25.8242 16.0613 26.0534 16.3468 26.0534 16.6765V17.6103H27.6654V16.6784C27.6654 16.3483 27.895 16.0627 28.2173 15.9917C28.9416 15.8323 29.619 15.5478 30.2256 15.1614C30.3884 15.0577 30.5867 15.0255 30.7739 15.0723L30.7742 15.0724C30.8978 15.1033 31.0107 15.1672 31.1008 15.2573L31.7585 15.9149L32.8983 14.775L32.2427 14.1194C32.1108 13.9875 32.0368 13.8087 32.0368 13.6222V13.622C32.0368 13.4877 32.0752 13.3563 32.1476 13.2432C32.5357 12.6363 32.8216 11.9583 32.9821 11.2332C33.0534 10.9112 33.3388 10.682 33.6686 10.682H34.5938V9.06998H33.6705C33.3404 9.06998 33.0547 8.84033 32.9838 8.51793C32.824 7.79179 32.5385 7.11274 32.1505 6.50496C32.0463 6.34172 32.0141 6.14274 32.0614 5.95495L32.0614 5.95467C32.0924 5.83148 32.1563 5.71899 32.2461 5.62916L32.8983 4.97694L31.7584 3.83705L31.1062 4.48928C31.0165 4.57893 30.9043 4.64267 30.7814 4.67375L30.7811 4.67382C30.5931 4.72136 30.3938 4.68915 30.2304 4.58482C29.6227 4.19686 28.9436 3.9114 28.2174 3.75156C27.895 3.68061 27.6654 3.39496 27.6654 3.06487V2.14165L26.0534 2.14162V3.06677C26.0534 3.39654 25.8242 3.682 25.5022 3.75328C24.7771 3.9138 24.0991 4.19969 23.4923 4.5878C23.4714 4.60111 23.45 4.61331 23.4279 4.62435C23.2544 4.71109 23.0922 4.70478 22.9978 4.68908C22.9489 4.68094 22.9081 4.66882 22.8772 4.6578C22.8613 4.65215 22.8469 4.64639 22.8342 4.64088C22.8278 4.6381 22.8217 4.63535 22.8159 4.63266C22.8144 4.63198 22.813 4.6313 22.8116 4.63062C22.8102 4.62996 22.8088 4.6293 22.8074 4.62864L22.8033 4.62666L22.8013 4.62567L22.8004 4.62518L22.7999 4.62494C22.7996 4.62482 22.7994 4.62469 23.1131 3.99546ZM32.4679 17.1942L32.2557 17.4064C31.9811 17.681 31.5359 17.681 31.2613 17.4065L30.49 16.6352C30.0421 16.8758 29.5674 17.0731 29.0716 17.2218V18.3135C29.0716 18.7018 28.7568 19.0166 28.3685 19.0166H25.3503C24.9619 19.0166 24.6471 18.7018 24.6471 18.3135V17.2192C24.1524 17.0702 23.6787 16.8728 23.2317 16.6322L22.4575 17.4065C22.1829 17.681 21.7377 17.681 21.4631 17.4064L19.3289 15.2722C19.0543 14.9977 19.0543 14.5525 19.3289 14.2779L20.1031 13.5036C19.8626 13.0566 19.6651 12.583 19.5161 12.0883H18.422C18.2369 12.0883 18.0592 12.0153 17.9276 11.8852L17.9276 11.8851C17.794 11.753 17.7188 11.573 17.7188 11.3851V8.36685C17.7188 7.97853 18.0336 7.66373 18.4219 7.66373H19.5136C19.6343 7.26125 19.787 6.87266 19.969 6.50099H2.81487C2.03694 6.50099 1.4063 7.1316 1.4063 7.90963V20.915H6.77346C7.16178 20.915 7.47658 21.2298 7.47658 21.6182C7.47658 22.0065 7.16178 22.3213 6.77346 22.3213H1.4063V24.2983H27.5464C27.9347 24.2983 28.2495 24.6131 28.2495 25.0014C28.2495 25.3897 27.9347 25.7045 27.5464 25.7045H1.4063V27.3111C1.4063 28.0891 2.03694 28.7197 2.81487 28.7197H31.0592C31.8373 28.7197 32.4679 28.0891 32.4679 27.3111V17.1942ZM15.3934 30.126V32.5166H18.4871V30.126H15.3934ZM14.6881 33.9228H12.3022C11.6795 33.9228 11.1746 34.4277 11.1746 35.0504V35.3291H22.7059V35.0504C22.7059 34.4277 22.2011 33.9228 21.5784 33.9228H19.1924C19.1917 33.9228 19.191 33.9228 19.1903 33.9228H14.6903C14.6895 33.9228 14.6888 33.9228 14.6881 33.9228ZM22.5 9.87598C22.5 7.46835 24.4517 5.51661 26.8594 5.51661C29.267 5.51661 31.2187 7.46835 31.2187 9.87598C31.2187 12.2836 29.267 14.2354 26.8594 14.2354C24.4517 14.2354 22.5 12.2836 22.5 9.87598ZM26.8594 6.92286C25.2284 6.92286 23.9063 8.245 23.9063 9.87598C23.9063 11.507 25.2284 12.8291 26.8594 12.8291C28.4904 12.8291 29.8125 11.507 29.8125 9.87598C29.8125 8.245 28.4904 6.92286 26.8594 6.92286ZM9.61757 9.73536C9.61757 9.34704 9.93236 9.03224 10.3207 9.03224H12.695C13.0833 9.03224 13.3981 9.34704 13.3981 9.73536V10.516C13.6456 10.6307 13.8808 10.7671 14.1013 10.9227L14.7779 10.532C14.9394 10.4387 15.1313 10.4135 15.3115 10.4617C15.4916 10.51 15.6452 10.6279 15.7384 10.7894L16.9256 12.8456C17.1197 13.1819 17.0045 13.612 16.6682 13.8061L15.9917 14.1967C16.0037 14.3305 16.0099 14.466 16.0099 14.6027C16.0099 14.7395 16.0037 14.8749 15.9917 15.0088L16.6682 15.3994C17.0045 15.5935 17.1197 16.0235 16.9256 16.3598L15.7384 18.4161C15.6452 18.5776 15.4916 18.6955 15.3115 18.7437C15.1313 18.792 14.9394 18.7667 14.7779 18.6735L14.1013 18.2828C13.8808 18.4384 13.6456 18.5748 13.3981 18.6894V19.4701C13.3981 19.8584 13.0833 20.1732 12.695 20.1732H10.3207C9.93236 20.1732 9.61757 19.8584 9.61757 19.4701V18.6895C9.37005 18.5748 9.13483 18.4384 8.91434 18.2828L8.2377 18.6735C8.0762 18.7667 7.88427 18.792 7.70414 18.7437C7.52401 18.6955 7.37043 18.5776 7.27719 18.4161L6.09004 16.3598C5.89588 16.0235 6.01111 15.5935 6.3474 15.3994L7.0239 15.0088C7.01188 14.8749 7.00574 14.7395 7.00574 14.6027C7.00574 14.466 7.01188 14.3305 7.0239 14.1967L6.3474 13.8061C6.01111 13.612 5.89588 13.1819 6.09004 12.8456L7.27719 10.7894C7.37043 10.6279 7.52401 10.51 7.70414 10.4617C7.88427 10.4135 8.0762 10.4387 8.2377 10.532L8.91434 10.9227C9.13483 10.7671 9.37005 10.6307 9.61757 10.516V9.73536ZM11.0238 10.4385V10.9933C11.0238 11.297 10.8288 11.5663 10.5403 11.6612C10.1315 11.7956 9.75971 12.0131 9.44512 12.2945C9.21871 12.497 8.88786 12.5312 8.62481 12.3793L8.14348 12.1014L7.65944 12.9398L8.14002 13.2173C8.40281 13.369 8.53862 13.6722 8.47687 13.9693C8.43445 14.1734 8.41199 14.3852 8.41199 14.6027C8.41199 14.8203 8.43445 15.0321 8.47687 15.2362C8.53862 15.5333 8.40281 15.8365 8.14002 15.9882L7.65944 16.2657L8.14348 17.1041L8.62481 16.8262C8.88786 16.6743 9.21871 16.7085 9.44512 16.911C9.75971 17.1923 10.1315 17.4099 10.5403 17.5443C10.8288 17.6391 11.0238 17.9085 11.0238 18.2122V18.767H11.9919V18.2122C11.9919 17.9085 12.1869 17.6391 12.4754 17.5443C12.8841 17.4099 13.2559 17.1924 13.5705 16.911C13.7969 16.7085 14.1278 16.6743 14.3908 16.8262L14.8721 17.1041L15.3562 16.2657L14.8756 15.9882C14.6128 15.8365 14.477 15.5333 14.5388 15.2362C14.5812 15.0321 14.6036 14.8203 14.6036 14.6027C14.6036 14.3852 14.5812 14.1734 14.5388 13.9693C14.477 13.6722 14.6128 13.369 14.8756 13.2173L15.3562 12.9398L14.8721 12.1014L14.3908 12.3793C14.1278 12.5312 13.7969 12.497 13.5705 12.2945C13.2559 12.0131 12.8841 11.7956 12.4754 11.6612C12.1869 11.5663 11.9919 11.297 11.9919 10.9933V10.4385H11.0238Z" fill="#7703FC" />
									</svg>
								</div>
								<span className="text-subheading fw-600">Learning Experience Platform</span>
							</div>
							<div className="d-none visible-for-mobile">
								<div className="paragraph-wrapper flex justify-center align-center">
									<span
										className={`text-subheading text-center fw-500 `}
									>
										Personalized learning journeys to upskill your team and drive performance.
									</span>
								</div>
							</div>
						</div>
						<div className="paragraph-wrapper flex justify-center align-center hide-for-mobile">
							<span
								className={`text-subheading  fw-500 ${hoveredCard === 1 ? "visible" : "hide"
									}`}
							>
								Simplify document approvals with integrated e-signatures, making onboarding and compliance a breeze.
							</span>
							<span
								className={`text-subheading  fw-500 ${hoveredCard === 2 ? "visible" : "hide"
									}`}
							>
								A centralized hub for all HR data, giving you unmatched control and insights.
							</span>
							<span
								className={`text-subheading  fw-500 ${hoveredCard === 3 ? "visible" : "hide"
									}`}
							>
								Automated payroll solutions with compliance for multiple geographies.
							</span>
							<span
								className={`text-subheading  fw-500 ${hoveredCard === 4 ? "visible" : "hide"
									}`}
							>
								Real-time tools to track employee satisfaction and engagement, empowering you to act proactively.
							</span>
							<span
								className={`text-subheading fw-500 ${hoveredCard === 5 ? "visible" : "hide"
									}`}
							>
								Personalized learning journeys to upskill your team and drive performance.
							</span>
						</div>
					</div>
					<div className="footer-content flex justify-center align-center">
						<span className="text-heading-1 fw-600">Be the First to Experience Our New Modules</span>
						<div className="button-wrapper flex justify-center">
							<button className="btn btn--regular btn--primary">
								Explore the Roadmap
							</button>
						</div>
					</div>
				</div>
			</section>
			{/*------------Journey-With-Product------------*/}

			{/*------------testimonial-slider-section------------*/}
			{/* <section className="testimonial-slider-section">
				<div className="heading-sec container">
					<h3 className="text-center fw-700 text-heading heading">Trusted By Teams Across <span className="primary-text-color">Industries</span></h3>
					<p className="sub-heading text-subheading text-center">From faster recruitment to smoother payroll, here's how Symplora transforms HR management for organizations like yours.</p>
				</div>
				<Swiper
					slidesPerView={3.5}
					spaceBetween={30}
					loop={true}
					pagination={{
						clickable: true,
					}}
					// navigation={true}
					modules={[Autoplay, Pagination, Navigation]}
					autoplay={{
						delay: 4500,
						disableOnInteraction: false,
					}}
					speed={1000}
					breakpoints={{

						240: {
							slidesPerView: 1,
							spaceBetween: 20,
						},
						// >= 640px (mobile)
						640: {
							slidesPerView: 1.5,
							spaceBetween: 20,
						},
						// >= 768px (tablets)
						768: {
							slidesPerView: 2.5,
							spaceBetween: 25,
						},
						1400: {
							slidesPerView: 3.5,
							spaceBetween: 30,
						}
						,
						2200: {
							slidesPerView: 4.5,
							spaceBetween: 30,
						}
					}}
					className="mySwiper"
				>
					<SwiperSlide>
						<p className="content text-body">
							Cardinal ensures we're making decisions based on data we
							can trust and gives stakeholders visibility into results without
							constant back and forth among teams. Cardinal solves that
							for us and provides a central place for our whole company to
							see the true impact of our entire product strategy as a whole.
						</p>
						<div className="profile-info-wrapper flex space-between align-center">
							<div className="profile-info flex align-center">
								<div className="avatar">
									<img src={BrianSimmonsImg} alt="Brian Simmons" />
								</div>
								<div>
									<span className="text-body fw-700 name">Brian Simmons</span>
									<p className="text-body-1 text-light-2">VP Product</p>
									<p className="text-body-1 text-light-2">TataCliq</p>
								</div>
							</div>
							<div className="company-logo">
								<img src={rapidoSvg} alt="rapido-logo" />
							</div>
						</div>
					</SwiperSlide>
					<SwiperSlide>
						<p className="content text-body">
							Cardinal is a lifesaver for us! We've been with them
							throughout 2023 and I can't remember how we were
							managing customer feedback, our backlog or a product
							roadmap before! Everyone is now aligned on the product at all
							times.
						</p>
						<div className="profile-info-wrapper flex space-between align-center">
							<div className="profile-info flex align-center">
								<div className="avatar">
									<img src={DummyProfileImg} alt="Brian Simmons" />
								</div>
								<div>
									<span className="text-body fw-700 name">Brian Simmons</span>
									<p className="text-body-1 text-light-2">VP Product</p>
									<p className="text-body-1 text-light-2">TataCliq</p>
								</div>
							</div>
							<div className="company-logo">
								<svg xmlns="http://www.w3.org/2000/svg" width="131" height="20" viewBox="0 0 131 20" fill="none">
									<g clip-path="url(#clip0_1971_688)">
										<path d="M4.82049 19.2747V0.750977H10.7431C12.0671 0.750977 13.0414 0.825721 13.6917 0.975209C15.7917 1.45144 17.54 3.07873 17.54 5.5816C17.54 7.15766 16.7895 8.56069 15.3909 9.33589C17.4142 10.0363 18.4397 11.5142 18.4397 13.6412C18.4397 15.418 17.6892 17.0453 16.2906 18.0212C14.8408 19.0484 13.8921 19.2726 10.967 19.2726H4.81836L4.82049 19.2747ZM11.2186 7.78549C12.3933 7.78549 13.018 7.28579 13.018 6.30768C13.018 5.3296 12.4189 4.90676 11.2442 4.90676H9.34458V7.78549H11.2186ZM11.8923 15.292C13.2845 15.292 14.1501 14.6876 14.1501 13.4233C14.1501 12.2915 13.389 11.7405 11.9179 11.7405H9.34458V15.292H11.8923Z" fill="#13293E" />
										<path d="M28.2618 19.2747V11.6402C28.2618 9.83773 27.5625 8.81054 26.0381 8.81054C24.5138 8.81054 23.7143 9.73738 23.7143 11.4629V19.2726H19.5654V0.750977H23.7143V6.70914C24.3134 5.58373 25.6629 4.90676 27.3131 4.90676C30.4876 4.90676 32.4107 6.90989 32.4107 10.5382V19.2747H28.2618Z" fill="#13293E" />
										<path d="M44.5284 19.2747V17.7734H44.4794C43.8803 18.9992 42.2302 19.751 40.4052 19.751C36.3075 19.751 33.457 16.522 33.457 12.3171C33.457 8.11218 36.4311 4.90674 40.4052 4.90674C42.1044 4.90674 43.6799 5.58371 44.4794 6.85865H44.5284V5.38083H48.6773V19.2747H44.5284ZM44.5284 12.315C44.5284 10.3631 42.955 8.78489 41.0042 8.78489C39.0535 8.78489 37.6059 10.3609 37.6059 12.3641C37.6059 14.3672 39.1302 15.8685 41.0554 15.8685C42.9806 15.8685 44.5284 14.316 44.5284 12.3128V12.315Z" fill="#13293E" />
										<path d="M50.4279 19.2745V5.38278H54.3273V6.86058H54.3763C55.1012 5.38278 56.2504 4.90869 57.8494 4.90869V9.09011C55.3763 9.1157 54.5746 10.0404 54.5746 11.6186V19.2788H50.4258L50.4279 19.2745Z" fill="#13293E" />
										<path d="M68.9209 19.2747V17.7734H68.8723C68.273 18.9992 66.6228 19.751 64.7977 19.751C60.6999 19.751 57.8496 16.522 57.8496 12.3171C57.8496 8.11218 60.8238 4.90674 64.7977 4.90674C66.4971 4.90674 68.0727 5.58371 68.8723 6.85865H68.9209V5.38083H73.0696V19.2747H68.9209ZM68.9209 12.315C68.9209 10.3631 67.3477 8.78489 65.3969 8.78489C63.4462 8.78489 61.9986 10.3609 61.9986 12.3641C61.9986 14.3672 63.5226 15.8685 65.4479 15.8685C67.3732 15.8685 68.9209 14.316 68.9209 12.3128V12.315Z" fill="#13293E" />
										<path d="M82.3678 5.38085V8.53504H80.3678V19.2747H76.2209V8.53504H74.1699V5.38085H76.2209V0.750977H80.3678V5.38085H82.3678Z" fill="#13293E" />
										<path d="M103.274 19.2746V17.7968H103.225C102.626 19.0738 101.526 19.7252 99.6514 19.7252C96.7285 19.7252 94.3047 17.9719 94.3047 14.0168V5.38281H98.4534V13.1669C98.4534 14.9949 99.1037 15.8449 100.677 15.8449C102.251 15.8449 103.052 14.7942 103.052 13.0921V5.38281H107.201V19.2767H103.278L103.274 19.2746Z" fill="#13293E" />
										<path d="M108.921 19.2745V5.38278H112.82V6.86058H112.87C113.595 5.38278 114.744 4.90869 116.343 4.90869V9.09011C113.87 9.1157 113.068 10.0404 113.068 11.6186V19.2788H108.919L108.921 19.2745Z" fill="#13293E" />
										<path d="M130.774 10.3782L127.393 13.195C127.333 14.0193 127.022 14.6643 126.316 15.2622C125.02 16.3642 123.331 16.4197 122.139 15.3626L130.069 8.62707C129.883 8.29177 129.691 8.02696 129.433 7.7216C126.653 4.43923 122.114 3.99503 118.95 6.68156C115.843 9.3211 115.637 14.03 118.223 17.0838C120.89 20.2337 125.529 20.5263 128.578 17.9338C130.691 16.1399 131.501 13.3616 130.774 10.3782ZM121.214 9.35524C122.434 8.31737 124 8.23412 125.171 9.1118L120.368 13.1928C119.662 11.856 120.072 10.327 121.214 9.35524Z" fill="#13293E" />
										<path d="M87.5761 10.2287H86.8938C88.5375 8.61213 90.1818 6.99553 91.8255 5.37891C90.2393 5.38744 88.6531 5.39813 87.0687 5.40666L82.1055 9.65642V10.1839L87.7509 15.1363H88.4332C88.2886 15.2622 88.1392 15.3861 87.994 15.5121C87.6638 15.7983 87.3289 16.0844 86.9922 16.3706C86.4208 16.8511 85.8493 17.3359 85.2803 17.8227C84.7089 18.3097 84.1375 18.7944 83.5684 19.2749H88.4931L93.4562 15.0252V14.4998L87.5761 10.2287Z" fill="#08A6DF" />
										<path d="M4.81999 0.750977H0.295898V4.90676H4.81999V0.750977Z" fill="#F2663F" />
										<path d="M4.81999 7.78564H0.295898V11.7407H4.81999V7.78564Z" fill="#78C477" />
									</g>
									<defs>
										<clipPath id="clip0_1971_688">
											<rect width="131" height="19" fill="white" transform="translate(0 0.750977)" />
										</clipPath>
									</defs>
								</svg>
							</div>
						</div>
					</SwiperSlide>
					<SwiperSlide>
						<p className="content text-body">
							Holding a product strategy at scale is insanely complicated.
							Cardinal offers us something we couldn't find elsewhere
							(including Productboard).  we're handling thousands of
							feedback items, features, and initiatives across many teams!
						</p>
						<div className="profile-info-wrapper flex space-between align-center">
							<div className="profile-info flex align-center">
								<div className="avatar">
									<img src={DummyProfileImg1} alt="Brian Simmons" />
								</div>
								<div>
									<span className="text-body fw-700 name">Brian Simmons</span>
									<p className="text-body-1 text-light-2">VP Product</p>
									<p className="text-body-1 text-light-2">TataCliq</p>
								</div>
							</div>
							<div className="company-logo">
								<svg xmlns="http://www.w3.org/2000/svg" width="79" height="24" viewBox="0 0 79 24" fill="none">
									<g clip-path="url(#clip0_1971_720)">
										<path d="M19.2736 21.8114H12.0693L10.9464 18.5818H8.32673L7.20387 21.8114H0L9.6368 0.894043L19.2736 21.8114ZM10.6424 13.8865C10.6424 13.6055 10.5409 13.3569 10.3384 13.1417C10.1354 12.926 9.9014 12.8182 9.6368 12.8182C9.37171 12.8182 9.13772 12.926 8.93519 13.1417C8.73217 13.3569 8.63068 13.6055 8.63068 13.8865C8.63068 14.1681 8.73217 14.4167 8.93519 14.6319C9.13772 14.8475 9.37171 14.9549 9.6368 14.9549C9.9014 14.9549 10.1354 14.8475 10.3384 14.6319C10.5409 14.4167 10.6424 14.1681 10.6424 13.8865ZM32.4421 15.4521L31.039 21.8114H19.9053V2.93134H26.922V15.4521H32.4421ZM46.4759 15.4521L45.0727 21.8114H33.939V2.93134H40.9562V15.4521H46.4759ZM61.6798 15.4521L60.0893 21.8114H47.9733V2.93134H60.0893L61.6798 9.29106H54.9904C54.7095 9.29106 54.5849 9.56944 54.6158 9.83452C54.6475 10.0662 54.7716 10.3053 54.9904 10.3053H58.9666V14.4379H54.9904C54.741 14.4379 54.6158 14.6948 54.6158 14.9434C54.6158 15.1919 54.741 15.4521 54.9904 15.4521H61.6798ZM78.8949 23.7494L70.6619 16.843V21.8114H63.5979V1.78863L71.8784 7.89975V2.9314H78.895L78.8949 23.7494Z" fill="#233A6C" />
									</g>
									<defs>
										<clipPath id="clip0_1971_720">
											<rect width="79" height="22.8554" fill="white" transform="translate(0 0.894043)" />
										</clipPath>
									</defs>
								</svg>
							</div>
						</div>
					</SwiperSlide>
					<SwiperSlide>
						<p className="content text-body">
							Cardinal ensures we're making decisions based on data we
							can trust and gives stakeholders visibility into results without
							constant back and forth among teams. Cardinal solves that
							for us and provides a central place for our whole company to
							see the true impact of our entire product strategy as a whole.
						</p>
						<div className="profile-info-wrapper flex space-between align-center">
							<div className="profile-info flex align-center">
								<div className="avatar">
									<img src={BrianSimmonsImg} alt="Brian Simmons" />
								</div>
								<div>
									<span className="text-body fw-700 name">Brian Simmons</span>
									<p className="text-body-1 text-light-2">VP Product</p>
									<p className="text-body-1 text-light-2">TataCliq</p>
								</div>
							</div>
							<div className="company-logo">
								<svg xmlns="http://www.w3.org/2000/svg" width="76" height="49" viewBox="0 0 76 49" fill="none">
									<path d="M44.1064 13.3984H49.6824V15.151H48.03V19.4441H45.7665V15.151H44.1071V13.3984H44.1064Z" fill="black" />
									<path d="M52.8773 15.7871L51.5823 19.4435H49.2764L51.5982 13.3984H54.1545L56.4794 19.4435H54.1862L52.8773 15.7871Z" fill="black" />
									<path d="M40.9036 15.7871L39.6087 19.4435H37.3027L39.6245 13.3984H42.1808L44.5058 19.4435H42.2125L40.9036 15.7871Z" fill="black" />
									<path d="M10.9536 13.5562H24.7848C27.0559 13.5562 28.8966 15.4095 28.8966 17.6948V31.6166C28.8966 33.9025 27.0553 35.7553 24.7848 35.7553H10.9536C8.6825 35.7553 6.8418 33.9019 6.8418 31.6166V17.6948C6.8418 15.4089 8.68313 13.5562 10.9536 13.5562Z" fill="#AB1E40" />
									<path d="M67.571 29.1382C67.6046 26.8344 65.7239 24.8885 63.4218 24.8445C61.0651 24.7992 59.0622 26.7432 59.002 29.1331C58.9462 31.3706 60.9365 33.4013 63.2171 33.432C65.639 33.4651 67.5361 31.5939 67.571 29.1382ZM68.4704 32.889C68.9445 33.356 69.4186 33.8262 69.8978 34.2913C70.2091 34.5944 70.2959 34.9606 70.1729 35.3651C70.0449 35.7894 69.7349 36.0299 69.302 36.0931C68.9445 36.1454 68.6504 35.9954 68.4019 35.7498C68.0052 35.3568 67.6058 34.967 67.2243 34.5599C67.0677 34.3922 66.9644 34.3647 66.7546 34.4981C65.6574 35.1954 64.4531 35.5297 63.1518 35.5157C60.1682 35.4831 57.534 33.1659 57.0358 30.1967C56.4292 26.5818 59.0603 23.3905 62.3119 22.861C65.7353 22.3027 69.0136 24.648 69.546 28.0868C69.7983 29.7175 69.5029 31.2443 68.6092 32.6421C68.568 32.7072 68.5332 32.7774 68.4704 32.889Z" fill="black" />
									<path d="M34.2209 29.2328C34.2526 30.0692 34.3312 30.889 34.591 31.6853C34.9935 32.9204 35.8727 33.561 37.1226 33.6886C37.6272 33.7402 38.1469 33.7166 38.6534 33.6656C39.4869 33.5807 40.1315 33.1176 40.7292 32.5523C40.9403 32.352 41.2452 32.1835 41.5273 32.1427C41.9 32.0891 42.2023 32.3181 42.3766 32.6735C42.5592 33.0461 42.499 33.3868 42.2442 33.7007C41.5659 34.5377 40.6811 35.0475 39.6606 35.3301C38.1958 35.7365 36.736 35.7046 35.3016 35.1987C34.0187 34.7457 33.1205 33.8493 32.6686 32.5727C31.8902 30.3716 31.863 28.1354 32.666 25.9388C33.369 24.0165 34.8636 23.1016 36.8323 22.8694C37.8871 22.745 38.919 22.8113 39.9268 23.1469C40.78 23.4308 41.5013 23.9183 42.0527 24.6405C42.2606 24.9136 42.4134 25.2121 42.3304 25.5726C42.1617 26.3069 41.2889 26.5628 40.7248 26.0441C40.4548 25.7953 40.2044 25.5184 39.9097 25.3034C38.8277 24.5135 36.961 24.4574 35.8252 25.1662C34.953 25.7104 34.5815 26.5736 34.4085 27.5351C34.3084 28.0946 34.2817 28.6669 34.2209 29.2328Z" fill="black" />
									<path d="M46.2926 33.4108H46.7369C48.0281 33.4108 49.3192 33.4064 50.6104 33.4121C51.1003 33.414 51.4299 33.6437 51.5656 34.0488C51.6987 34.4418 51.6043 34.8572 51.2753 35.1073C51.1263 35.2215 50.9165 35.314 50.734 35.3159C48.8755 35.3325 47.0171 35.3395 45.1586 35.3255C44.5837 35.321 44.2237 34.9057 44.2231 34.3181C44.2199 30.8786 44.2199 27.4392 44.2231 24.0004C44.2231 23.3751 44.6668 22.9285 45.2626 22.9336C45.859 22.9387 46.2907 23.3873 46.2907 24.0163C46.2932 26.997 46.292 29.9765 46.292 32.9566L46.2926 33.4108Z" fill="black" />
									<path d="M55.225 30.8438C55.225 31.9532 55.2301 33.0627 55.2231 34.1728C55.218 34.9531 54.7135 35.4176 53.9978 35.3187C53.6188 35.2663 53.2632 34.9486 53.1834 34.5748C53.1529 34.4344 53.1377 34.2864 53.1377 34.1416C53.1352 31.9679 53.1358 29.7936 53.1358 27.6193C53.1358 27.1887 53.2157 26.7976 53.6137 26.5417C54.2565 26.1296 55.0767 26.4913 55.199 27.2474C55.2205 27.3794 55.2269 27.5153 55.2269 27.6493C55.2294 28.7141 55.2281 29.7789 55.2281 30.8431H55.225V30.8438Z" fill="black" />
									<path d="M55.533 23.4262C55.9399 23.8358 55.9399 24.5019 55.533 24.9108C55.1261 25.3211 54.4643 25.3211 54.058 24.9108L52.7789 23.624C52.372 23.2144 52.372 22.549 52.7783 22.1387C53.1858 21.7291 53.8469 21.7291 54.2532 22.1387L55.533 23.4262Z" fill="#AB1E40" />
									<path d="M22.7518 24.7297C22.7879 22.2294 20.7475 20.1182 18.2495 20.0704C15.6926 20.0212 13.5185 22.1305 13.4538 24.7239C13.393 27.1521 15.5531 29.3558 18.0277 29.389C20.655 29.4247 22.7137 27.3946 22.7518 24.7297ZM23.7279 28.7994C24.2426 29.306 24.7566 29.8164 25.277 30.3217C25.6149 30.6509 25.7087 31.0477 25.5756 31.4873C25.4361 31.9473 25.1002 32.2089 24.6305 32.2772C24.2426 32.334 23.9231 32.1713 23.6537 31.9052C23.2234 31.479 22.7898 31.056 22.3759 30.6139C22.206 30.4321 22.0945 30.4021 21.8663 30.5469C20.6753 31.3036 19.3689 31.666 17.9567 31.6513C14.719 31.6162 11.8603 29.1012 11.3197 25.88C10.6611 21.9576 13.5166 18.4945 17.0446 17.9197C20.7596 17.3142 24.3167 19.8586 24.8942 23.5902C25.168 25.36 24.8473 27.0169 23.8775 28.5334C23.8331 28.6029 23.7957 28.6782 23.7279 28.7994Z" fill="white" />
									<path d="M32.1465 13.3984H37.7225V15.151H36.07V19.4441H33.8059V15.151H32.1465V13.3984Z" fill="black" />
								</svg>
							</div>
						</div>
					</SwiperSlide>
					<SwiperSlide>
						<p className="content text-body">
							Cardinal ensures we're making decisions based on data we
							can trust and gives stakeholders visibility into results without
							constant back and forth among teams. Cardinal solves that
							for us and provides a central place for our whole company to
							see the true impact of our entire product strategy as a whole.
						</p>
						<div className="profile-info-wrapper flex space-between align-center">
							<div className="profile-info flex align-center">
								<div className="avatar">
									<img src={BrianSimmonsImg} alt="Brian Simmons" />
								</div>
								<div>
									<span className="text-body fw-700 name">Brian Simmons</span>
									<p className="text-body-1 text-light-2">VP Product</p>
									<p className="text-body-1 text-light-2">TataCliq</p>
								</div>
							</div>
							<div className="company-logo">
								<svg xmlns="http://www.w3.org/2000/svg" width="76" height="49" viewBox="0 0 76 49" fill="none">
									<path d="M44.1064 13.3984H49.6824V15.151H48.03V19.4441H45.7665V15.151H44.1071V13.3984H44.1064Z" fill="black" />
									<path d="M52.8773 15.7871L51.5823 19.4435H49.2764L51.5982 13.3984H54.1545L56.4794 19.4435H54.1862L52.8773 15.7871Z" fill="black" />
									<path d="M40.9036 15.7871L39.6087 19.4435H37.3027L39.6245 13.3984H42.1808L44.5058 19.4435H42.2125L40.9036 15.7871Z" fill="black" />
									<path d="M10.9536 13.5562H24.7848C27.0559 13.5562 28.8966 15.4095 28.8966 17.6948V31.6166C28.8966 33.9025 27.0553 35.7553 24.7848 35.7553H10.9536C8.6825 35.7553 6.8418 33.9019 6.8418 31.6166V17.6948C6.8418 15.4089 8.68313 13.5562 10.9536 13.5562Z" fill="#AB1E40" />
									<path d="M67.571 29.1382C67.6046 26.8344 65.7239 24.8885 63.4218 24.8445C61.0651 24.7992 59.0622 26.7432 59.002 29.1331C58.9462 31.3706 60.9365 33.4013 63.2171 33.432C65.639 33.4651 67.5361 31.5939 67.571 29.1382ZM68.4704 32.889C68.9445 33.356 69.4186 33.8262 69.8978 34.2913C70.2091 34.5944 70.2959 34.9606 70.1729 35.3651C70.0449 35.7894 69.7349 36.0299 69.302 36.0931C68.9445 36.1454 68.6504 35.9954 68.4019 35.7498C68.0052 35.3568 67.6058 34.967 67.2243 34.5599C67.0677 34.3922 66.9644 34.3647 66.7546 34.4981C65.6574 35.1954 64.4531 35.5297 63.1518 35.5157C60.1682 35.4831 57.534 33.1659 57.0358 30.1967C56.4292 26.5818 59.0603 23.3905 62.3119 22.861C65.7353 22.3027 69.0136 24.648 69.546 28.0868C69.7983 29.7175 69.5029 31.2443 68.6092 32.6421C68.568 32.7072 68.5332 32.7774 68.4704 32.889Z" fill="black" />
									<path d="M34.2209 29.2328C34.2526 30.0692 34.3312 30.889 34.591 31.6853C34.9935 32.9204 35.8727 33.561 37.1226 33.6886C37.6272 33.7402 38.1469 33.7166 38.6534 33.6656C39.4869 33.5807 40.1315 33.1176 40.7292 32.5523C40.9403 32.352 41.2452 32.1835 41.5273 32.1427C41.9 32.0891 42.2023 32.3181 42.3766 32.6735C42.5592 33.0461 42.499 33.3868 42.2442 33.7007C41.5659 34.5377 40.6811 35.0475 39.6606 35.3301C38.1958 35.7365 36.736 35.7046 35.3016 35.1987C34.0187 34.7457 33.1205 33.8493 32.6686 32.5727C31.8902 30.3716 31.863 28.1354 32.666 25.9388C33.369 24.0165 34.8636 23.1016 36.8323 22.8694C37.8871 22.745 38.919 22.8113 39.9268 23.1469C40.78 23.4308 41.5013 23.9183 42.0527 24.6405C42.2606 24.9136 42.4134 25.2121 42.3304 25.5726C42.1617 26.3069 41.2889 26.5628 40.7248 26.0441C40.4548 25.7953 40.2044 25.5184 39.9097 25.3034C38.8277 24.5135 36.961 24.4574 35.8252 25.1662C34.953 25.7104 34.5815 26.5736 34.4085 27.5351C34.3084 28.0946 34.2817 28.6669 34.2209 29.2328Z" fill="black" />
									<path d="M46.2926 33.4108H46.7369C48.0281 33.4108 49.3192 33.4064 50.6104 33.4121C51.1003 33.414 51.4299 33.6437 51.5656 34.0488C51.6987 34.4418 51.6043 34.8572 51.2753 35.1073C51.1263 35.2215 50.9165 35.314 50.734 35.3159C48.8755 35.3325 47.0171 35.3395 45.1586 35.3255C44.5837 35.321 44.2237 34.9057 44.2231 34.3181C44.2199 30.8786 44.2199 27.4392 44.2231 24.0004C44.2231 23.3751 44.6668 22.9285 45.2626 22.9336C45.859 22.9387 46.2907 23.3873 46.2907 24.0163C46.2932 26.997 46.292 29.9765 46.292 32.9566L46.2926 33.4108Z" fill="black" />
									<path d="M55.225 30.8438C55.225 31.9532 55.2301 33.0627 55.2231 34.1728C55.218 34.9531 54.7135 35.4176 53.9978 35.3187C53.6188 35.2663 53.2632 34.9486 53.1834 34.5748C53.1529 34.4344 53.1377 34.2864 53.1377 34.1416C53.1352 31.9679 53.1358 29.7936 53.1358 27.6193C53.1358 27.1887 53.2157 26.7976 53.6137 26.5417C54.2565 26.1296 55.0767 26.4913 55.199 27.2474C55.2205 27.3794 55.2269 27.5153 55.2269 27.6493C55.2294 28.7141 55.2281 29.7789 55.2281 30.8431H55.225V30.8438Z" fill="black" />
									<path d="M55.533 23.4262C55.9399 23.8358 55.9399 24.5019 55.533 24.9108C55.1261 25.3211 54.4643 25.3211 54.058 24.9108L52.7789 23.624C52.372 23.2144 52.372 22.549 52.7783 22.1387C53.1858 21.7291 53.8469 21.7291 54.2532 22.1387L55.533 23.4262Z" fill="#AB1E40" />
									<path d="M22.7518 24.7297C22.7879 22.2294 20.7475 20.1182 18.2495 20.0704C15.6926 20.0212 13.5185 22.1305 13.4538 24.7239C13.393 27.1521 15.5531 29.3558 18.0277 29.389C20.655 29.4247 22.7137 27.3946 22.7518 24.7297ZM23.7279 28.7994C24.2426 29.306 24.7566 29.8164 25.277 30.3217C25.6149 30.6509 25.7087 31.0477 25.5756 31.4873C25.4361 31.9473 25.1002 32.2089 24.6305 32.2772C24.2426 32.334 23.9231 32.1713 23.6537 31.9052C23.2234 31.479 22.7898 31.056 22.3759 30.6139C22.206 30.4321 22.0945 30.4021 21.8663 30.5469C20.6753 31.3036 19.3689 31.666 17.9567 31.6513C14.719 31.6162 11.8603 29.1012 11.3197 25.88C10.6611 21.9576 13.5166 18.4945 17.0446 17.9197C20.7596 17.3142 24.3167 19.8586 24.8942 23.5902C25.168 25.36 24.8473 27.0169 23.8775 28.5334C23.8331 28.6029 23.7957 28.6782 23.7279 28.7994Z" fill="white" />
									<path d="M32.1465 13.3984H37.7225V15.151H36.07V19.4441H33.8059V15.151H32.1465V13.3984Z" fill="black" />
								</svg>
							</div>
						</div>
					</SwiperSlide>
					<SwiperSlide>
						<p className="content text-body">
							Cardinal ensures we're making decisions based on data we
							can trust and gives stakeholders visibility into results without
							constant back and forth among teams. Cardinal solves that
							for us and provides a central place for our whole company to
							see the true impact of our entire product strategy as a whole.
						</p>
						<div className="profile-info-wrapper flex space-between align-center">
							<div className="profile-info flex align-center">
								<div className="avatar">
									<img src={BrianSimmonsImg} alt="Brian Simmons" />
								</div>
								<div>
									<span className="text-body fw-700 name">Brian Simmons</span>
									<p className="text-body-1 text-light-2">VP Product</p>
									<p className="text-body-1 text-light-2">TataCliq</p>
								</div>
							</div>
							<div className="company-logo">
								<img src={rapidoSvg} alt="rapido-logo" />
							</div>
						</div>
					</SwiperSlide>
				</Swiper>
			</section> */}
			{/*------------testimonial-slider-section------------*/}

			{/*------------book-a-demo-section------------*/}
			<section className="container book-a-demo-section">
				<div className="book-a-demo-banner">
					<div className="content-wrapper">
						<h4 ref={bookDemoHeadingRef} style={{ transform: "translateY(50px)" }}>Ready To Transform Your HR Processes?</h4>
						<p ref={bookDemoSubHeadingRef} style={{ transform: "translateY(50px)" }} className='text-heading-1'>Symplora is your partner in building a more efficient, empowered HR team. Let's start transforming your workplace today.</p>
						<button className='btn btn--outlined btn-white btn--regular'>Book A Demo</button>
					</div>
					<img className='banner-boy-img' src={BoyWithLaptop} alt="Boy with laptop in banner img" />
				</div>
			</section>
			{/*------------book-a-demo-section------------*/}

			{/* Enquiry Modal */}
			{isModalOpen && (
				<div className="modal-overlay" onClick={handleCloseModal}>
					<div className="modal-content" onClick={(e) => e.stopPropagation()}>
						<button className="modal-close" onClick={handleCloseModal}>
							<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
							</svg>
						</button>
						
						<h2 className="modal-title text-heading-1 fw-700">Request a Quote</h2>
						<p className="modal-subtitle text-body">Fill in the details below and our team will get back to you shortly.</p>
						
						<form onSubmit={handleSubmit} className="enquiry-form">
							<div className="form-fields-section">
								<div className="form-inputs-wrapper">
									<div className="form-row">
									<div className="form-group full-width">
										<input
											type="email"
											name="workEmail"
											value={formData.workEmail}
											onChange={handleInputChange}
											placeholder="Work Email*"
											required
											className="form-input"
										/>
									</div>
								</div>

								<div className="form-row">
									<div className="form-group">
										<input
											type="text"
											name="firstName"
											value={formData.firstName}
											onChange={handleInputChange}
											placeholder="First Name*"
											required
											className="form-input"
										/>
									</div>
									<div className="form-group">
										<input
											type="text"
											name="lastName"
											value={formData.lastName}
											onChange={handleInputChange}
											placeholder="Last Name*"
											required
											className="form-input"
										/>
									</div>
								</div>

								<div className="form-row">
									<div className="form-group">
										<select
											name="country"
											value={formData.country}
											onChange={handleInputChange}
											className="form-input"
										>
											<option value="India">India (+भारत)</option>
											<option value="USA">USA</option>
											<option value="UK">UK</option>
											<option value="Canada">Canada</option>
											<option value="Australia">Australia</option>
										</select>
									</div>
									<div className="form-group">
										<input
											type="tel"
											name="phone"
											value={formData.phone}
											onChange={handleInputChange}
											placeholder="+91"
											required
											className="form-input"
										/>
									</div>
								</div>

								<div className="form-row">
									<div className="form-group">
										<input
											type="text"
											name="companyName"
											value={formData.companyName}
											onChange={handleInputChange}
											placeholder="Company Name*"
											required
											className="form-input"
										/>
									</div>
									<div className="form-group">
										<select
											name="numberOfEmployees"
											value={formData.numberOfEmployees}
											onChange={handleInputChange}
											required
											className="form-input"
										>
											<option value="">Number of Employees*</option>
											<option value="1-10">1-10</option>
											<option value="11-50">11-50</option>
											<option value="51-200">51-200</option>
											<option value="201-500">201-500</option>
											<option value="501-1000">501-1000</option>
											<option value="1000+">1000+</option>
										</select>
									</div>
								</div>

								<div className="form-row">
									<div className="form-group">
										<select
											name="seniority"
											value={formData.seniority}
											onChange={handleInputChange}
											required
											className="form-input"
										>
											<option value="">Seniority*</option>
											<option value="C-Level">C-Level</option>
											<option value="VP">VP</option>
											<option value="Director">Director</option>
											<option value="Manager">Manager</option>
											<option value="Individual Contributor">Individual Contributor</option>
										</select>
									</div>
									<div className="form-group">
										<select
											name="functionalArea"
											value={formData.functionalArea}
											onChange={handleInputChange}
											required
											className="form-input"
										>
											<option value="">Functional Area*</option>
											<option value="HR">HR</option>
											<option value="IT">IT</option>
											<option value="Finance">Finance</option>
											<option value="Operations">Operations</option>
											<option value="Sales">Sales</option>
											<option value="Marketing">Marketing</option>
											<option value="Other">Other</option>
										</select>
									</div>
								</div>

								<div className="form-row">
									<div className="form-group full-width">
										<textarea
											name="customisation"
											value={formData.customisation}
											onChange={handleInputChange}
											placeholder="Any other customisation"
											className="form-input"
											rows="3"
										/>
									</div>
								</div>
							</div>
						</div>

						<div className="modules-section">
								<h3 className="modules-title text-body fw-600">Select the Modules you are interested in*</h3>
								<div className="modules-grid">
									{[
										'Core HR',
										"ESOP & Captable Management",
										"Employee Sentiment",
										'Talent Acquisition',
										'Performance Management',
										// 'Time and Attendance Management',
										// 'Talent Management',
										'Payroll',
										// 'Employee Helpdesk',
										// 'Rewards & Recognition',
										// 'Employee Engagement',
										'Compensation Planning',
										'Time and Attendance Management',
										// 'Travel & Expense Management',
										// 'HR Analytics'
									].map((module) => (
										<label key={module} className="module-checkbox">
											<input
												type="checkbox"
												checked={formData.modules.includes(module)}
												onChange={() => handleModuleChange(module)}
											/>
											<span className="checkbox-label">{module}</span>
										</label>
									))}
								</div>
							</div>

							<div className="form-bottom-section">
								<div className="form-group checkbox-group">
									<label className="checkbox-container">
										<input
											type="checkbox"
											name="agreedToTerms"
											checked={formData.agreedToTerms}
											onChange={handleInputChange}
											required
										/>
										<span className="checkbox-text">
											I have read and understood the <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>, <a href="/terms-of-use" target="_blank" rel="noopener noreferrer">Terms of Use</a>
										</span>
									</label>
								</div>

							<button 
								type="submit" 
								className="btn btn--primary btn--regular submit-btn" 
								disabled={isSubmitting || !isFormValid()}
							>
								{isSubmitting ? 'REQUESTING QUOTE...' : 'REQUEST A QUOTE'}
							</button>
							</div>
						</form>
					</div>
				</div>
			)}

		</>
	);
};

export default Home;
